var tl = Object.defineProperty;
var nl = (r, e, t) => e in r ? tl(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var Ur = (r, e, t) => nl(r, typeof e != "symbol" ? e + "" : e, t);
import Cs, { isAxiosError as al } from "axios";
import { useMemo as ol } from "react";
var bt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function il(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Z = function(r) {
  try {
    return !!r();
  } catch {
    return !0;
  }
}, sl = Z, Xe = !sl(function() {
  var r = (function() {
  }).bind();
  return typeof r != "function" || r.hasOwnProperty("prototype");
}), As = Xe, Ds = Function.prototype, Mn = Ds.call, cl = As && Ds.bind.bind(Mn, Mn), lr = As ? cl : function(r) {
  return function() {
    return Mn.apply(r, arguments);
  };
}, ul = lr, js = ul({}.isPrototypeOf), me = function(r) {
  return r && r.Math === Math && r;
}, rr = (
  // eslint-disable-next-line es/no-global-this -- safe
  me(typeof globalThis == "object" && globalThis) || me(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  me(typeof self == "object" && self) || me(typeof bt == "object" && bt) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || bt || Function("return this")()
), ll = Xe, xs = Function.prototype, Za = xs.apply, ro = xs.call, vl = typeof Reflect == "object" && Reflect.apply || (ll ? ro.bind(Za) : function() {
  return ro.apply(Za, arguments);
}), Ns = lr, fl = Ns({}.toString), dl = Ns("".slice), Qe = function(r) {
  return dl(fl(r), 8, -1);
}, pl = Qe, $l = lr, ks = function(r) {
  if (pl(r) === "Function") return $l(r);
}, Fn = typeof document == "object" && document.all, hl = typeof Fn > "u" && Fn !== void 0, Ms = {
  all: Fn,
  IS_HTMLDDA: hl
}, Fs = Ms, yl = Fs.all, er = Fs.IS_HTMLDDA ? function(r) {
  return typeof r == "function" || r === yl;
} : function(r) {
  return typeof r == "function";
}, Ls = {}, gl = Z, Zr = !gl(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), ml = Xe, be = Function.prototype.call, fa = ml ? be.bind(be) : function() {
  return be.apply(be, arguments);
}, Bs = {}, Us = {}.propertyIsEnumerable, Ks = Object.getOwnPropertyDescriptor, bl = Ks && !Us.call({ 1: 2 }, 1);
Bs.f = bl ? function(e) {
  var t = Ks(this, e);
  return !!t && t.enumerable;
} : Us;
var Gs = function(r, e) {
  return {
    enumerable: !(r & 1),
    configurable: !(r & 2),
    writable: !(r & 4),
    value: e
  };
}, Sl = lr, Ol = Z, _l = Qe, St = Object, Tl = Sl("".split), El = Ol(function() {
  return !St("z").propertyIsEnumerable(0);
}) ? function(r) {
  return _l(r) === "String" ? Tl(r, "") : St(r);
} : St, Vs = function(r) {
  return r == null;
}, wl = Vs, Il = TypeError, da = function(r) {
  if (wl(r)) throw Il("Can't call method on " + r);
  return r;
}, Pl = El, Rl = da, Ws = function(r) {
  return Pl(Rl(r));
}, eo = er, Hs = Ms, Cl = Hs.all, re = Hs.IS_HTMLDDA ? function(r) {
  return typeof r == "object" ? r !== null : eo(r) || r === Cl;
} : function(r) {
  return typeof r == "object" ? r !== null : eo(r);
}, pa = {}, Ot = pa, _t = rr, Al = er, to = function(r) {
  return Al(r) ? r : void 0;
}, Dl = function(r, e) {
  return arguments.length < 2 ? to(Ot[r]) || to(_t[r]) : Ot[r] && Ot[r][e] || _t[r] && _t[r][e];
}, jl = typeof navigator < "u" && String(navigator.userAgent) || "", Ys = rr, Tt = jl, no = Ys.process, ao = Ys.Deno, oo = no && no.versions || ao && ao.version, io = oo && oo.v8, F, Ve;
io && (F = io.split("."), Ve = F[0] > 0 && F[0] < 4 ? 1 : +(F[0] + F[1]));
!Ve && Tt && (F = Tt.match(/Edge\/(\d+)/), (!F || F[1] >= 74) && (F = Tt.match(/Chrome\/(\d+)/), F && (Ve = +F[1])));
var xl = Ve, so = xl, Nl = Z, kl = rr, Ml = kl.String, zs = !!Object.getOwnPropertySymbols && !Nl(function() {
  var r = Symbol("symbol detection");
  return !Ml(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && so && so < 41;
}), Fl = zs, qs = Fl && !Symbol.sham && typeof Symbol.iterator == "symbol", Ll = Dl, Bl = er, Ul = js, Kl = qs, Gl = Object, Js = Kl ? function(r) {
  return typeof r == "symbol";
} : function(r) {
  var e = Ll("Symbol");
  return Bl(e) && Ul(e.prototype, Gl(r));
}, Vl = String, Wl = function(r) {
  try {
    return Vl(r);
  } catch {
    return "Object";
  }
}, Hl = er, Yl = Wl, zl = TypeError, Xs = function(r) {
  if (Hl(r)) return r;
  throw zl(Yl(r) + " is not a function");
}, ql = Xs, Jl = Vs, Xl = function(r, e) {
  var t = r[e];
  return Jl(t) ? void 0 : ql(t);
}, Et = fa, wt = er, It = re, Ql = TypeError, Zl = function(r, e) {
  var t, n;
  if (e === "string" && wt(t = r.toString) && !It(n = Et(t, r)) || wt(t = r.valueOf) && !It(n = Et(t, r)) || e !== "string" && wt(t = r.toString) && !It(n = Et(t, r))) return n;
  throw Ql("Can't convert object to primitive value");
}, Qs = { exports: {} }, co = rr, rv = Object.defineProperty, ev = function(r, e) {
  try {
    rv(co, r, { value: e, configurable: !0, writable: !0 });
  } catch {
    co[r] = e;
  }
  return e;
}, tv = rr, nv = ev, uo = "__core-js_shared__", av = tv[uo] || nv(uo, {}), ov = av, lo = ov;
(Qs.exports = function(r, e) {
  return lo[r] || (lo[r] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var iv = Qs.exports, sv = da, cv = Object, uv = function(r) {
  return cv(sv(r));
}, lv = lr, vv = uv, fv = lv({}.hasOwnProperty), $a = Object.hasOwn || function(e, t) {
  return fv(vv(e), t);
}, dv = lr, pv = 0, $v = Math.random(), hv = dv(1 .toString), yv = function(r) {
  return "Symbol(" + (r === void 0 ? "" : r) + ")_" + hv(++pv + $v, 36);
}, gv = rr, mv = iv, vo = $a, bv = yv, Sv = zs, Ov = qs, br = gv.Symbol, Pt = mv("wks"), _v = Ov ? br.for || br : br && br.withoutSetter || bv, ee = function(r) {
  return vo(Pt, r) || (Pt[r] = Sv && vo(br, r) ? br[r] : _v("Symbol." + r)), Pt[r];
}, Tv = fa, fo = re, po = Js, Ev = Xl, wv = Zl, Iv = ee, Pv = TypeError, Rv = Iv("toPrimitive"), Cv = function(r, e) {
  if (!fo(r) || po(r)) return r;
  var t = Ev(r, Rv), n;
  if (t) {
    if (e === void 0 && (e = "default"), n = Tv(t, r, e), !fo(n) || po(n)) return n;
    throw Pv("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), wv(r, e);
}, Av = Cv, Dv = Js, Zs = function(r) {
  var e = Av(r, "string");
  return Dv(e) ? e : e + "";
}, jv = rr, $o = re, Ln = jv.document, xv = $o(Ln) && $o(Ln.createElement), Nv = function(r) {
  return xv ? Ln.createElement(r) : {};
}, kv = Zr, Mv = Z, Fv = Nv, rc = !kv && !Mv(function() {
  return Object.defineProperty(Fv("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), Lv = Zr, Bv = fa, Uv = Bs, Kv = Gs, Gv = Ws, Vv = Zs, Wv = $a, Hv = rc, ho = Object.getOwnPropertyDescriptor;
Ls.f = Lv ? ho : function(e, t) {
  if (e = Gv(e), t = Vv(t), Hv) try {
    return ho(e, t);
  } catch {
  }
  if (Wv(e, t)) return Kv(!Bv(Uv.f, e, t), e[t]);
};
var Yv = Z, zv = er, qv = /#|\.prototype\./, te = function(r, e) {
  var t = Xv[Jv(r)];
  return t === Zv ? !0 : t === Qv ? !1 : zv(e) ? Yv(e) : !!e;
}, Jv = te.normalize = function(r) {
  return String(r).replace(qv, ".").toLowerCase();
}, Xv = te.data = {}, Qv = te.NATIVE = "N", Zv = te.POLYFILL = "P", rf = te, yo = ks, ef = Xs, tf = Xe, nf = yo(yo.bind), af = function(r, e) {
  return ef(r), e === void 0 ? r : tf ? nf(r, e) : function() {
    return r.apply(e, arguments);
  };
}, ec = {}, of = Zr, sf = Z, cf = of && sf(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), uf = re, lf = String, vf = TypeError, ff = function(r) {
  if (uf(r)) return r;
  throw vf(lf(r) + " is not an object");
}, df = Zr, pf = rc, $f = cf, Se = ff, go = Zs, hf = TypeError, Rt = Object.defineProperty, yf = Object.getOwnPropertyDescriptor, Ct = "enumerable", At = "configurable", Dt = "writable";
ec.f = df ? $f ? function(e, t, n) {
  if (Se(e), t = go(t), Se(n), typeof e == "function" && t === "prototype" && "value" in n && Dt in n && !n[Dt]) {
    var a = yf(e, t);
    a && a[Dt] && (e[t] = n.value, n = {
      configurable: At in n ? n[At] : a[At],
      enumerable: Ct in n ? n[Ct] : a[Ct],
      writable: !1
    });
  }
  return Rt(e, t, n);
} : Rt : function(e, t, n) {
  if (Se(e), t = go(t), Se(n), pf) try {
    return Rt(e, t, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw hf("Accessors not supported");
  return "value" in n && (e[t] = n.value), e;
};
var gf = Zr, mf = ec, bf = Gs, Sf = gf ? function(r, e, t) {
  return mf.f(r, e, bf(1, t));
} : function(r, e, t) {
  return r[e] = t, r;
}, Oe = rr, Of = vl, _f = ks, Tf = er, Ef = Ls.f, wf = rf, dr = pa, If = af, pr = Sf, mo = $a, Pf = function(r) {
  var e = function(t, n, a) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new r();
        case 1:
          return new r(t);
        case 2:
          return new r(t, n);
      }
      return new r(t, n, a);
    }
    return Of(r, this, arguments);
  };
  return e.prototype = r.prototype, e;
}, tc = function(r, e) {
  var t = r.target, n = r.global, a = r.stat, o = r.proto, i = n ? Oe : a ? Oe[t] : (Oe[t] || {}).prototype, s = n ? dr : dr[t] || pr(dr, t, {})[t], u = s.prototype, l, c, f, v, d, $, h, p, y;
  for (v in e)
    l = wf(n ? v : t + (a ? "." : "#") + v, r.forced), c = !l && i && mo(i, v), $ = s[v], c && (r.dontCallGetSet ? (y = Ef(i, v), h = y && y.value) : h = i[v]), d = c && h ? h : e[v], !(c && typeof $ == typeof d) && (r.bind && c ? p = If(d, Oe) : r.wrap && c ? p = Pf(d) : o && Tf(d) ? p = _f(d) : p = d, (r.sham || d && d.sham || $ && $.sham) && pr(p, "sham", !0), pr(s, v, p), o && (f = t + "Prototype", mo(dr, f) || pr(dr, f, {}), pr(dr[f], v, d), r.real && u && (l || !u[v]) && pr(u, v, d)));
}, Rf = Math.ceil, Cf = Math.floor, Af = Math.trunc || function(e) {
  var t = +e;
  return (t > 0 ? Cf : Rf)(t);
}, Df = Af, nc = function(r) {
  var e = +r;
  return e !== e || e === 0 ? 0 : Df(e);
}, jf = nc, xf = Math.max, Nf = Math.min, kf = function(r, e) {
  var t = jf(r);
  return t < 0 ? xf(t + e, 0) : Nf(t, e);
}, Mf = nc, Ff = Math.min, Lf = function(r) {
  return r > 0 ? Ff(Mf(r), 9007199254740991) : 0;
}, Bf = Lf, Uf = function(r) {
  return Bf(r.length);
}, Kf = Ws, Gf = kf, Vf = Uf, Wf = function(r) {
  return function(e, t, n) {
    var a = Kf(e), o = Vf(a), i = Gf(n, o), s;
    if (r && t !== t) {
      for (; o > i; )
        if (s = a[i++], s !== s) return !0;
    } else for (; o > i; i++)
      if ((r || i in a) && a[i] === t) return r || i || 0;
    return !r && -1;
  };
}, Hf = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Wf(!0)
}, Yf = tc, zf = Hf.includes, qf = Z, Jf = qf(function() {
  return !Array(1).includes();
});
Yf({ target: "Array", proto: !0, forced: Jf }, {
  includes: function(e) {
    return zf(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Xf = pa, ac = function(r) {
  return Xf[r + "Prototype"];
}, Qf = ac, Zf = Qf("Array").includes, rd = re, ed = Qe, td = ee, nd = td("match"), ad = function(r) {
  var e;
  return rd(r) && ((e = r[nd]) !== void 0 ? !!e : ed(r) === "RegExp");
}, od = ad, id = TypeError, sd = function(r) {
  if (od(r))
    throw id("The method doesn't accept regular expressions");
  return r;
}, cd = ee, ud = cd("toStringTag"), oc = {};
oc[ud] = "z";
var ld = String(oc) === "[object z]", vd = ld, fd = er, Fe = Qe, dd = ee, pd = dd("toStringTag"), $d = Object, hd = Fe(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", yd = function(r, e) {
  try {
    return r[e];
  } catch {
  }
}, gd = vd ? Fe : function(r) {
  var e, t, n;
  return r === void 0 ? "Undefined" : r === null ? "Null" : typeof (t = yd(e = $d(r), pd)) == "string" ? t : hd ? Fe(e) : (n = Fe(e)) === "Object" && fd(e.callee) ? "Arguments" : n;
}, md = gd, bd = String, Sd = function(r) {
  if (md(r) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return bd(r);
}, Od = ee, _d = Od("match"), Td = function(r) {
  var e = /./;
  try {
    "/./"[r](e);
  } catch {
    try {
      return e[_d] = !1, "/./"[r](e);
    } catch {
    }
  }
  return !1;
}, Ed = tc, wd = lr, Id = sd, Pd = da, bo = Sd, Rd = Td, Cd = wd("".indexOf);
Ed({ target: "String", proto: !0, forced: !Rd("includes") }, {
  includes: function(e) {
    return !!~Cd(
      bo(Pd(this)),
      bo(Id(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var Ad = ac, Dd = Ad("String").includes, So = js, jd = Zf, xd = Dd, jt = Array.prototype, xt = String.prototype, Nd = function(r) {
  var e = r.includes;
  return r === jt || So(jt, r) && e === jt.includes ? jd : typeof r == "string" || r === xt || So(xt, r) && e === xt.includes ? xd : e;
}, kd = Nd, Md = kd, Fd = Md, _e = /* @__PURE__ */ il(Fd);
function Oo(r) {
  r = r.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const t = new RegExp(`[\\?&]${r}=([^&#]*)`).exec(location.search);
  return t === null ? null : Ld(t[1].replace(/\+/g, " "));
}
function Ld(r) {
  try {
    return decodeURIComponent(r);
  } catch {
    return console.warn(`Failed to decode param value '${r}'`), r;
  }
}
function Bd() {
  const r = Oo("staging") || Oo("backend-domain");
  if (r) {
    const e = /^\d+$/.test(r) ? `euw1.stag${r === "1" ? "" : r}.dixa.io` : r;
    return sessionStorage.setItem("dixa:backend-domain", e), e;
  }
  return null;
}
var _o, To, Eo, Nt, kt, Mt, Ft, Lt, Bt, Ut, Kt;
const or = {
  restApiUrl: "_dixa-rest-api-url",
  partnerIntegrationsApiUrl: "_dixa-partner-integrations-api-url",
  filesApiUrl: "_dixa-files-api-url",
  loginUrl: "_dixa-login-url",
  signUpUrl: "_dixa-sign-up-url",
  subdomain: "_dixa-subdomain",
  webSocketUrl: "_dixa-websocket-url"
}, Ud = {
  backendDomain: "dixa:backend-domain"
}, Gt = window.location.origin.replace(/^https?:\/\//, ""), S = (Nt = Bd()) !== null && Nt !== void 0 ? Nt : sessionStorage.getItem(Ud.backendDomain), m = {
  // The development domains.
  develop: ["localhost:8080", "dixadev.com", "dixa.io"],
  // The testing domains.
  test: {
    // The security testing domains.
    security: ["dixa-security.com", "dixa-security.net"],
    // The automation testing domains.
    automation: ["localhost:9999", "test-agent-interface.dixa.io", "test.dixatest.com", "okta-test-org.dixatest.com"]
  },
  // The custom subdomains.
  custom: ["thehaddaway.dixa.com", "demo.dixa.com", "developer.dixa.com", "okta-test.dixa.com", "development.dixa.com", "engineering.dixa.com"],
  default: {
    email: "dixa.com",
    emailIntegration: "email.dixa.io",
    integrations: "docs.dixa.io",
    service: "dixa.io",
    status: "status.dixa.io",
    subdomain: (kt = localStorage.getItem(or.subdomain)) !== null && kt !== void 0 ? kt : "demo",
    userContent: "dixausercontent.com",
    web: "dixa.com",
    accounts: "accounts.dixa.com",
    knowledge: "knowledge-backend-cdn"
  }
}, Kd = {
  assets: `https://assets.${m.default.service}`,
  toolkit: `https://toolkit.${m.default.service}`,
  widget: `https://widget.${m.default.service}`,
  rest: (Mt = localStorage.getItem(or.restApiUrl)) !== null && Mt !== void 0 ? Mt : `https://api.${S ?? m.default.service}`,
  partnerIntegrations: (Ft = localStorage.getItem(or.partnerIntegrationsApiUrl)) !== null && Ft !== void 0 ? Ft : `https://partner-integrations.${S ?? m.default.service}`,
  files: (Lt = localStorage.getItem(or.filesApiUrl)) !== null && Lt !== void 0 ? Lt : `https://files.${S ?? m.default.service}`,
  webSocket: (Bt = localStorage.getItem(or.webSocketUrl)) !== null && Bt !== void 0 ? Bt : `wss://agent-sockets.${S ?? m.default.service}/v2/agent/`,
  userContent: S ? `https://raw.${S.replace(m.default.service, m.default.userContent)}` : `https://raw.${m.default.userContent}`,
  signUp: (Ut = localStorage.getItem(or.signUpUrl)) !== null && Ut !== void 0 ? Ut : `https://${m.default.accounts}/signup`,
  logIn: (Kt = localStorage.getItem(or.loginUrl)) !== null && Kt !== void 0 ? Kt : `https://${m.default.accounts}/signin`,
  smartConversationReply: Bn(S) === "prod" ? `https://knowledge-backend-cdn.${m.default.service}` : `https://knowledge-backend-cdn.stag.${m.default.service}`,
  dixaKnowledgeBackend: Bn(S) === "prod" ? `https://knowledge-backend.${m.default.service}` : `https://knowledge-backend.stag.${m.default.service}`
}, Gd = {
  amplitude: {
    environment: _e(_o = [...m.test.automation, ...m.develop, ...m.test.security, ...m.custom]).call(_o, Gt) || S != null && _e(S).call(S, ".stag") ? "stag" : "prod"
  },
  launchDarkly: _e(To = m.develop).call(To, Gt) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
  stripe: _e(Eo = m.develop).call(Eo, Gt) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
  elevio: "599d54aacd7bd",
  birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
  jabra: {
    partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
    appId: "Dixa",
    appName: "Dixa"
  }
};
function Bn(r) {
  const e = r == null ? void 0 : r.match(/(stag\d?)/);
  return !e || e.length < 2 ? "prod" : e[1];
}
const Yr = {
  environment: Bn(S),
  domain: m.default,
  sdk: Gd,
  url: Kd,
  backendDomain: S
};
var Vt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vd(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Te = function(r) {
  return r && r.Math === Math && r;
}, E = (
  // eslint-disable-next-line es/no-global-this -- safe
  Te(typeof globalThis == "object" && globalThis) || Te(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Te(typeof self == "object" && self) || Te(typeof Vt == "object" && Vt) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Vt || Function("return this")()
), O = function(r) {
  try {
    return !!r();
  } catch {
    return !0;
  }
}, Wd = O, Ze = !Wd(function() {
  var r = (function() {
  }).bind();
  return typeof r != "function" || r.hasOwnProperty("prototype");
}), Hd = Ze, ic = Function.prototype, wo = ic.apply, Io = ic.call, ha = typeof Reflect == "object" && Reflect.apply || (Hd ? Io.bind(wo) : function() {
  return Io.apply(wo, arguments);
}), sc = Ze, cc = Function.prototype, Un = cc.call, Yd = sc && cc.bind.bind(Un, Un), w = sc ? Yd : function(r) {
  return function() {
    return Un.apply(r, arguments);
  };
}, uc = w, zd = uc({}.toString), qd = uc("".slice), vr = function(r) {
  return qd(zd(r), 8, -1);
}, Jd = vr, Xd = w, ya = function(r) {
  if (Jd(r) === "Function") return Xd(r);
}, Kn = typeof document == "object" && document.all, Qd = typeof Kn > "u" && Kn !== void 0, lc = {
  all: Kn,
  IS_HTMLDDA: Qd
}, vc = lc, Zd = vc.all, T = vc.IS_HTMLDDA ? function(r) {
  return typeof r == "function" || r === Zd;
} : function(r) {
  return typeof r == "function";
}, Dr = {}, rp = O, x = !rp(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), ep = Ze, Ee = Function.prototype.call, R = ep ? Ee.bind(Ee) : function() {
  return Ee.apply(Ee, arguments);
}, rt = {}, fc = {}.propertyIsEnumerable, dc = Object.getOwnPropertyDescriptor, tp = dc && !fc.call({ 1: 2 }, 1);
rt.f = tp ? function(e) {
  var t = dc(this, e);
  return !!t && t.enumerable;
} : fc;
var fr = function(r, e) {
  return {
    enumerable: !(r & 1),
    configurable: !(r & 2),
    writable: !(r & 4),
    value: e
  };
}, np = w, ap = O, op = vr, Wt = Object, ip = np("".split), ga = ap(function() {
  return !Wt("z").propertyIsEnumerable(0);
}) ? function(r) {
  return op(r) === "String" ? ip(r, "") : Wt(r);
} : Wt, et = function(r) {
  return r == null;
}, sp = et, cp = TypeError, ma = function(r) {
  if (sp(r)) throw cp("Can't call method on " + r);
  return r;
}, up = ga, lp = ma, q = function(r) {
  return up(lp(r));
}, Po = T, pc = lc, vp = pc.all, N = pc.IS_HTMLDDA ? function(r) {
  return typeof r == "object" ? r !== null : Po(r) || r === vp;
} : function(r) {
  return typeof r == "object" ? r !== null : Po(r);
}, k = {}, Ht = k, Yt = E, fp = T, Ro = function(r) {
  return fp(r) ? r : void 0;
}, M = function(r, e) {
  return arguments.length < 2 ? Ro(Ht[r]) || Ro(Yt[r]) : Ht[r] && Ht[r][e] || Yt[r] && Yt[r][e];
}, dp = w, ne = dp({}.isPrototypeOf), tt = typeof navigator < "u" && String(navigator.userAgent) || "", $c = E, zt = tt, Co = $c.process, Ao = $c.Deno, Do = Co && Co.versions || Ao && Ao.version, jo = Do && Do.v8, L, We;
jo && (L = jo.split("."), We = L[0] > 0 && L[0] < 4 ? 1 : +(L[0] + L[1]));
!We && zt && (L = zt.match(/Edge\/(\d+)/), (!L || L[1] >= 74) && (L = zt.match(/Chrome\/(\d+)/), L && (We = +L[1])));
var nt = We, xo = nt, pp = O, $p = E, hp = $p.String, jr = !!Object.getOwnPropertySymbols && !pp(function() {
  var r = Symbol("symbol detection");
  return !hp(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && xo && xo < 41;
}), yp = jr, hc = yp && !Symbol.sham && typeof Symbol.iterator == "symbol", gp = M, mp = T, bp = ne, Sp = hc, Op = Object, at = Sp ? function(r) {
  return typeof r == "symbol";
} : function(r) {
  var e = gp("Symbol");
  return mp(e) && bp(e.prototype, Op(r));
}, _p = String, ae = function(r) {
  try {
    return _p(r);
  } catch {
    return "Object";
  }
}, Tp = T, Ep = ae, wp = TypeError, V = function(r) {
  if (Tp(r)) return r;
  throw wp(Ep(r) + " is not a function");
}, Ip = V, Pp = et, ba = function(r, e) {
  var t = r[e];
  return Pp(t) ? void 0 : Ip(t);
}, qt = R, Jt = T, Xt = N, Rp = TypeError, Cp = function(r, e) {
  var t, n;
  if (e === "string" && Jt(t = r.toString) && !Xt(n = qt(t, r)) || Jt(t = r.valueOf) && !Xt(n = qt(t, r)) || e !== "string" && Jt(t = r.toString) && !Xt(n = qt(t, r))) return n;
  throw Rp("Can't convert object to primitive value");
}, yc = { exports: {} }, Ap = !0, No = E, Dp = Object.defineProperty, jp = function(r, e) {
  try {
    Dp(No, r, { value: e, configurable: !0, writable: !0 });
  } catch {
    No[r] = e;
  }
  return e;
}, xp = E, Np = jp, ko = "__core-js_shared__", kp = xp[ko] || Np(ko, {}), Sa = kp, Mo = Sa;
(yc.exports = function(r, e) {
  return Mo[r] || (Mo[r] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var oe = yc.exports, Mp = ma, Fp = Object, xr = function(r) {
  return Fp(Mp(r));
}, Lp = w, Bp = xr, Up = Lp({}.hasOwnProperty), A = Object.hasOwn || function(e, t) {
  return Up(Bp(e), t);
}, Kp = w, Gp = 0, Vp = Math.random(), Wp = Kp(1 .toString), Oa = function(r) {
  return "Symbol(" + (r === void 0 ? "" : r) + ")_" + Wp(++Gp + Vp, 36);
}, Hp = E, Yp = oe, Fo = A, zp = Oa, qp = jr, Jp = hc, Sr = Hp.Symbol, Qt = Yp("wks"), Xp = Jp ? Sr.for || Sr : Sr && Sr.withoutSetter || zp, _ = function(r) {
  return Fo(Qt, r) || (Qt[r] = qp && Fo(Sr, r) ? Sr[r] : Xp("Symbol." + r)), Qt[r];
}, Qp = R, Lo = N, Bo = at, Zp = ba, r$ = Cp, e$ = _, t$ = TypeError, n$ = e$("toPrimitive"), a$ = function(r, e) {
  if (!Lo(r) || Bo(r)) return r;
  var t = Zp(r, n$), n;
  if (t) {
    if (e === void 0 && (e = "default"), n = Qp(t, r, e), !Lo(n) || Bo(n)) return n;
    throw t$("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), r$(r, e);
}, o$ = a$, i$ = at, ot = function(r) {
  var e = o$(r, "string");
  return i$(e) ? e : e + "";
}, s$ = E, Uo = N, Gn = s$.document, c$ = Uo(Gn) && Uo(Gn.createElement), _a = function(r) {
  return c$ ? Gn.createElement(r) : {};
}, u$ = x, l$ = O, v$ = _a, gc = !u$ && !l$(function() {
  return Object.defineProperty(v$("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), f$ = x, d$ = R, p$ = rt, $$ = fr, h$ = q, y$ = ot, g$ = A, m$ = gc, Ko = Object.getOwnPropertyDescriptor;
Dr.f = f$ ? Ko : function(e, t) {
  if (e = h$(e), t = y$(t), m$) try {
    return Ko(e, t);
  } catch {
  }
  if (g$(e, t)) return $$(!d$(p$.f, e, t), e[t]);
};
var b$ = O, S$ = T, O$ = /#|\.prototype\./, ie = function(r, e) {
  var t = T$[_$(r)];
  return t === w$ ? !0 : t === E$ ? !1 : S$(e) ? b$(e) : !!e;
}, _$ = ie.normalize = function(r) {
  return String(r).replace(O$, ".").toLowerCase();
}, T$ = ie.data = {}, E$ = ie.NATIVE = "N", w$ = ie.POLYFILL = "P", mc = ie, Go = ya, I$ = V, P$ = Ze, R$ = Go(Go.bind), se = function(r, e) {
  return I$(r), e === void 0 ? r : P$ ? R$(r, e) : function() {
    return r.apply(e, arguments);
  };
}, U = {}, C$ = x, A$ = O, bc = C$ && A$(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), D$ = N, j$ = String, x$ = TypeError, K = function(r) {
  if (D$(r)) return r;
  throw x$(j$(r) + " is not an object");
}, N$ = x, k$ = gc, M$ = bc, we = K, Vo = ot, F$ = TypeError, Zt = Object.defineProperty, L$ = Object.getOwnPropertyDescriptor, rn = "enumerable", en = "configurable", tn = "writable";
U.f = N$ ? M$ ? function(e, t, n) {
  if (we(e), t = Vo(t), we(n), typeof e == "function" && t === "prototype" && "value" in n && tn in n && !n[tn]) {
    var a = L$(e, t);
    a && a[tn] && (e[t] = n.value, n = {
      configurable: en in n ? n[en] : a[en],
      enumerable: rn in n ? n[rn] : a[rn],
      writable: !1
    });
  }
  return Zt(e, t, n);
} : Zt : function(e, t, n) {
  if (we(e), t = Vo(t), we(n), k$) try {
    return Zt(e, t, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw F$("Accessors not supported");
  return "value" in n && (e[t] = n.value), e;
};
var B$ = x, U$ = U, K$ = fr, tr = B$ ? function(r, e, t) {
  return U$.f(r, e, K$(1, t));
} : function(r, e, t) {
  return r[e] = t, r;
}, Ie = E, G$ = ha, V$ = ya, W$ = T, H$ = Dr.f, Y$ = mc, $r = k, z$ = se, hr = tr, Wo = A, q$ = function(r) {
  var e = function(t, n, a) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new r();
        case 1:
          return new r(t);
        case 2:
          return new r(t, n);
      }
      return new r(t, n, a);
    }
    return G$(r, this, arguments);
  };
  return e.prototype = r.prototype, e;
}, g = function(r, e) {
  var t = r.target, n = r.global, a = r.stat, o = r.proto, i = n ? Ie : a ? Ie[t] : (Ie[t] || {}).prototype, s = n ? $r : $r[t] || hr($r, t, {})[t], u = s.prototype, l, c, f, v, d, $, h, p, y;
  for (v in e)
    l = Y$(n ? v : t + (a ? "." : "#") + v, r.forced), c = !l && i && Wo(i, v), $ = s[v], c && (r.dontCallGetSet ? (y = H$(i, v), h = y && y.value) : h = i[v]), d = c && h ? h : e[v], !(c && typeof $ == typeof d) && (r.bind && c ? p = z$(d, Ie) : r.wrap && c ? p = q$(d) : o && W$(d) ? p = V$(d) : p = d, (r.sham || d && d.sham || $ && $.sham) && hr(p, "sham", !0), hr(s, v, p), o && (f = t + "Prototype", Wo($r, f) || hr($r, f, {}), hr($r[f], v, d), r.real && u && (l || !u[v]) && hr(u, v, d)));
}, J$ = w, X$ = V, Q$ = function(r, e, t) {
  try {
    return J$(X$(Object.getOwnPropertyDescriptor(r, e)[t]));
  } catch {
  }
}, Z$ = T, rh = String, eh = TypeError, th = function(r) {
  if (typeof r == "object" || Z$(r)) return r;
  throw eh("Can't set " + rh(r) + " as a prototype");
}, nh = Q$, ah = K, oh = th, Sc = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var r = !1, e = {}, t;
  try {
    t = nh(Object.prototype, "__proto__", "set"), t(e, []), r = e instanceof Array;
  } catch {
  }
  return function(a, o) {
    return ah(a), oh(o), r ? t(a, o) : a.__proto__ = o, a;
  };
}() : void 0), ih = g, sh = Sc;
ih({ target: "Object", stat: !0 }, {
  setPrototypeOf: sh
});
var ch = k;
ch.Object.setPrototypeOf;
var Ta = {}, uh = Math.ceil, lh = Math.floor, vh = Math.trunc || function(e) {
  var t = +e;
  return (t > 0 ? lh : uh)(t);
}, fh = vh, Ea = function(r) {
  var e = +r;
  return e !== e || e === 0 ? 0 : fh(e);
}, dh = Ea, ph = Math.max, $h = Math.min, wa = function(r, e) {
  var t = dh(r);
  return t < 0 ? ph(t + e, 0) : $h(t, e);
}, hh = Ea, yh = Math.min, gh = function(r) {
  return r > 0 ? yh(hh(r), 9007199254740991) : 0;
}, mh = gh, Nr = function(r) {
  return mh(r.length);
}, bh = q, Sh = wa, Oh = Nr, _h = function(r) {
  return function(e, t, n) {
    var a = bh(e), o = Oh(a), i = Sh(n, o), s;
    if (r && t !== t) {
      for (; o > i; )
        if (s = a[i++], s !== s) return !0;
    } else for (; o > i; i++)
      if ((r || i in a) && a[i] === t) return r || i || 0;
    return !r && -1;
  };
}, Oc = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: _h(!1)
}, it = {}, Th = w, nn = A, Eh = q, wh = Oc.indexOf, Ih = it, Ho = Th([].push), _c = function(r, e) {
  var t = Eh(r), n = 0, a = [], o;
  for (o in t) !nn(Ih, o) && nn(t, o) && Ho(a, o);
  for (; e.length > n; ) nn(t, o = e[n++]) && (~wh(a, o) || Ho(a, o));
  return a;
}, Ia = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], Ph = _c, Rh = Ia, Pa = Object.keys || function(e) {
  return Ph(e, Rh);
}, Ch = x, Ah = bc, Dh = U, jh = K, xh = q, Nh = Pa;
Ta.f = Ch && !Ah ? Object.defineProperties : function(e, t) {
  jh(e);
  for (var n = xh(t), a = Nh(t), o = a.length, i = 0, s; o > i; ) Dh.f(e, s = a[i++], n[s]);
  return e;
};
var kh = M, Tc = kh("document", "documentElement"), Mh = oe, Fh = Oa, Yo = Mh("keys"), st = function(r) {
  return Yo[r] || (Yo[r] = Fh(r));
}, Lh = K, Bh = Ta, zo = Ia, Uh = it, Kh = Tc, Gh = _a, Vh = st, qo = ">", Jo = "<", Vn = "prototype", Wn = "script", Ec = Vh("IE_PROTO"), an = function() {
}, wc = function(r) {
  return Jo + Wn + qo + r + Jo + "/" + Wn + qo;
}, Xo = function(r) {
  r.write(wc("")), r.close();
  var e = r.parentWindow.Object;
  return r = null, e;
}, Wh = function() {
  var r = Gh("iframe"), e = "java" + Wn + ":", t;
  return r.style.display = "none", Kh.appendChild(r), r.src = String(e), t = r.contentWindow.document, t.open(), t.write(wc("document.F=Object")), t.close(), t.F;
}, Pe, Le = function() {
  try {
    Pe = new ActiveXObject("htmlfile");
  } catch {
  }
  Le = typeof document < "u" ? document.domain && Pe ? Xo(Pe) : Wh() : Xo(Pe);
  for (var r = zo.length; r--; ) delete Le[Vn][zo[r]];
  return Le();
};
Uh[Ec] = !0;
var ce = Object.create || function(e, t) {
  var n;
  return e !== null ? (an[Vn] = Lh(e), n = new an(), an[Vn] = null, n[Ec] = e) : n = Le(), t === void 0 ? n : Bh.f(n, t);
}, Hh = g, Yh = x, zh = ce;
Hh({ target: "Object", stat: !0, sham: !Yh }, {
  create: zh
});
var qh = k;
qh.Object;
var ue = {};
ue.f = Object.getOwnPropertySymbols;
var Qo = x, Jh = w, Xh = R, Qh = O, on = Pa, Zh = ue, ry = rt, ey = xr, ty = ga, yr = Object.assign, Zo = Object.defineProperty, ny = Jh([].concat), ay = !yr || Qh(function() {
  if (Qo && yr({ b: 1 }, yr(Zo({}, "a", {
    enumerable: !0,
    get: function() {
      Zo(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1) return !0;
  var r = {}, e = {}, t = Symbol("assign detection"), n = "abcdefghijklmnopqrst";
  return r[t] = 7, n.split("").forEach(function(a) {
    e[a] = a;
  }), yr({}, r)[t] !== 7 || on(yr({}, e)).join("") !== n;
}) ? function(e, t) {
  for (var n = ey(e), a = arguments.length, o = 1, i = Zh.f, s = ry.f; a > o; )
    for (var u = ty(arguments[o++]), l = i ? ny(on(u), i(u)) : on(u), c = l.length, f = 0, v; c > f; )
      v = l[f++], (!Qo || Xh(s, u, v)) && (n[v] = u[v]);
  return n;
} : yr, oy = g, ri = ay;
oy({ target: "Object", stat: !0, forced: Object.assign !== ri }, {
  assign: ri
});
var iy = k;
iy.Object.assign;
var sy = O, cy = function(r, e) {
  var t = [][r];
  return !!t && sy(function() {
    t.call(null, e || function() {
      return 1;
    }, 1);
  });
}, uy = g, ly = ya, vy = Oc.indexOf, fy = cy, Hn = ly([].indexOf), Ic = !!Hn && 1 / Hn([1], 1, -0) < 0, dy = Ic || !fy("indexOf");
uy({ target: "Array", proto: !0, forced: dy }, {
  indexOf: function(e) {
    var t = arguments.length > 1 ? arguments[1] : void 0;
    return Ic ? Hn(this, e, t) || 0 : vy(this, e, t);
  }
});
var py = k, Ra = function(r) {
  return py[r + "Prototype"];
}, $y = Ra;
$y("Array").indexOf;
var hy = _, yy = hy("toStringTag"), Pc = {};
Pc[yy] = "z";
var Ca = String(Pc) === "[object z]", gy = Ca, my = T, Be = vr, by = _, Sy = by("toStringTag"), Oy = Object, _y = Be(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", Ty = function(r, e) {
  try {
    return r[e];
  } catch {
  }
}, le = gy ? Be : function(r) {
  var e, t, n;
  return r === void 0 ? "Undefined" : r === null ? "Null" : typeof (t = Ty(e = Oy(r), Sy)) == "string" ? t : _y ? Be(e) : (n = Be(e)) === "Object" && my(e.callee) ? "Arguments" : n;
}, Ey = le, wy = String, kr = function(r) {
  if (Ey(r) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return wy(r);
}, ct = {}, Iy = _c, Py = Ia, Ry = Py.concat("length", "prototype");
ct.f = Object.getOwnPropertyNames || function(e) {
  return Iy(e, Ry);
};
var Rc = {}, Cy = ot, Ay = U, Dy = fr, Aa = function(r, e, t) {
  var n = Cy(e);
  n in r ? Ay.f(r, n, Dy(0, t)) : r[n] = t;
}, ei = wa, jy = Nr, xy = Aa, Ny = Array, ky = Math.max, My = function(r, e, t) {
  for (var n = jy(r), a = ei(e, n), o = ei(t === void 0 ? n : t, n), i = Ny(ky(o - a, 0)), s = 0; a < o; a++, s++) xy(i, s, r[a]);
  return i.length = s, i;
}, Fy = vr, Ly = q, Cc = ct.f, By = My, Ac = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], Uy = function(r) {
  try {
    return Cc(r);
  } catch {
    return By(Ac);
  }
};
Rc.f = function(e) {
  return Ac && Fy(e) === "Window" ? Uy(e) : Cc(Ly(e));
};
var Ky = tr, ve = function(r, e, t, n) {
  return n && n.enumerable ? r[e] = t : Ky(r, e, t), r;
}, Gy = U, Dc = function(r, e, t) {
  return Gy.f(r, e, t);
}, fe = {}, Vy = _;
fe.f = Vy;
var ti = k, Wy = A, Hy = fe, Yy = U.f, D = function(r) {
  var e = ti.Symbol || (ti.Symbol = {});
  Wy(e, r) || Yy(e, r, {
    value: Hy.f(r)
  });
}, zy = R, qy = M, Jy = _, Xy = ve, jc = function() {
  var r = qy("Symbol"), e = r && r.prototype, t = e && e.valueOf, n = Jy("toPrimitive");
  e && !e[n] && Xy(e, n, function(a) {
    return zy(t, this);
  }, {});
}, Qy = Ca, Zy = le, rg = Qy ? {}.toString : function() {
  return "[object " + Zy(this) + "]";
}, eg = Ca, tg = U.f, ng = tr, ag = A, og = rg, ig = _, ni = ig("toStringTag"), Mr = function(r, e, t, n) {
  if (r) {
    var a = t ? r : r.prototype;
    ag(a, ni) || tg(a, ni, { configurable: !0, value: e }), n && !eg && ng(a, "toString", og);
  }
}, sg = E, cg = T, ai = sg.WeakMap, ug = cg(ai) && /native code/.test(String(ai)), lg = ug, xc = E, vg = N, fg = tr, sn = A, cn = Sa, dg = st, pg = it, oi = "Object already initialized", Yn = xc.TypeError, $g = xc.WeakMap, He, zr, Ye, hg = function(r) {
  return Ye(r) ? zr(r) : He(r, {});
}, yg = function(r) {
  return function(e) {
    var t;
    if (!vg(e) || (t = zr(e)).type !== r)
      throw Yn("Incompatible receiver, " + r + " required");
    return t;
  };
};
if (lg || cn.state) {
  var G = cn.state || (cn.state = new $g());
  G.get = G.get, G.has = G.has, G.set = G.set, He = function(r, e) {
    if (G.has(r)) throw Yn(oi);
    return e.facade = r, G.set(r, e), e;
  }, zr = function(r) {
    return G.get(r) || {};
  }, Ye = function(r) {
    return G.has(r);
  };
} else {
  var gr = dg("state");
  pg[gr] = !0, He = function(r, e) {
    if (sn(r, gr)) throw Yn(oi);
    return e.facade = r, fg(r, gr, e), e;
  }, zr = function(r) {
    return sn(r, gr) ? r[gr] : {};
  }, Ye = function(r) {
    return sn(r, gr);
  };
}
var ut = {
  set: He,
  get: zr,
  has: Ye,
  enforce: hg,
  getterFor: yg
}, gg = vr, lt = Array.isArray || function(e) {
  return gg(e) === "Array";
}, mg = w, bg = T, zn = Sa, Sg = mg(Function.toString);
bg(zn.inspectSource) || (zn.inspectSource = function(r) {
  return Sg(r);
});
var Nc = zn.inspectSource, Og = w, _g = O, kc = T, Tg = le, Eg = M, wg = Nc, Mc = function() {
}, Ig = [], Fc = Eg("Reflect", "construct"), Da = /^\s*(?:class|function)\b/, Pg = Og(Da.exec), Rg = !Da.exec(Mc), Kr = function(e) {
  if (!kc(e)) return !1;
  try {
    return Fc(Mc, Ig, e), !0;
  } catch {
    return !1;
  }
}, Lc = function(e) {
  if (!kc(e)) return !1;
  switch (Tg(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return Rg || !!Pg(Da, wg(e));
  } catch {
    return !0;
  }
};
Lc.sham = !0;
var ja = !Fc || _g(function() {
  var r;
  return Kr(Kr.call) || !Kr(Object) || !Kr(function() {
    r = !0;
  }) || r;
}) ? Lc : Kr, ii = lt, Cg = ja, Ag = N, Dg = _, jg = Dg("species"), si = Array, xg = function(r) {
  var e;
  return ii(r) && (e = r.constructor, Cg(e) && (e === si || ii(e.prototype)) ? e = void 0 : Ag(e) && (e = e[jg], e === null && (e = void 0))), e === void 0 ? si : e;
}, Ng = xg, Bc = function(r, e) {
  return new (Ng(r))(e === 0 ? 0 : e);
}, kg = se, Mg = w, Fg = ga, Lg = xr, Bg = Nr, Ug = Bc, ci = Mg([].push), Kg = function(r) {
  var e = r === 1, t = r === 2, n = r === 3, a = r === 4, o = r === 6, i = r === 7, s = r === 5 || o;
  return function(u, l, c, f) {
    for (var v = Lg(u), d = Fg(v), $ = kg(l, c), h = Bg(d), p = 0, y = f || Ug, b = e ? y(u, h) : t || i ? y(u, 0) : void 0, Br, mt; h > p; p++) if ((s || p in d) && (Br = d[p], mt = $(Br, p, v), r))
      if (e) b[p] = mt;
      else if (mt) switch (r) {
        case 3:
          return !0;
        // some
        case 5:
          return Br;
        // find
        case 6:
          return p;
        // findIndex
        case 2:
          ci(b, Br);
      }
      else switch (r) {
        case 4:
          return !1;
        // every
        case 7:
          ci(b, Br);
      }
    return o ? -1 : n || a ? a : b;
  };
}, Gg = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: Kg(0)
}, vt = g, xa = E, Na = R, Vg = w, Ir = x, Pr = jr, Wg = O, I = A, Hg = ne, qn = K, ft = q, ka = ot, Yg = kr, Jn = fr, qr = ce, Uc = Pa, zg = ct, Kc = Rc, qg = ue, Gc = Dr, Vc = U, Jg = Ta, Wc = rt, ui = ve, Xg = Dc, Ma = oe, Qg = st, Hc = it, li = Oa, Zg = _, rm = fe, em = D, tm = jc, nm = Mr, Yc = ut, dt = Gg.forEach, C = Qg("hidden"), pt = "Symbol", Jr = "prototype", am = Yc.set, vi = Yc.getterFor(pt), B = Object[Jr], cr = xa.Symbol, Gr = cr && cr[Jr], om = xa.TypeError, un = xa.QObject, zc = Gc.f, sr = Vc.f, qc = Kc.f, im = Wc.f, Jc = Vg([].push), Y = Ma("symbols"), de = Ma("op-symbols"), sm = Ma("wks"), Xn = !un || !un[Jr] || !un[Jr].findChild, Qn = Ir && Wg(function() {
  return qr(sr({}, "a", {
    get: function() {
      return sr(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? function(r, e, t) {
  var n = zc(B, e);
  n && delete B[e], sr(r, e, t), n && r !== B && sr(B, e, n);
} : sr, ln = function(r, e) {
  var t = Y[r] = qr(Gr);
  return am(t, {
    type: pt,
    tag: r,
    description: e
  }), Ir || (t.description = e), t;
}, $t = function(e, t, n) {
  e === B && $t(de, t, n), qn(e);
  var a = ka(t);
  return qn(n), I(Y, a) ? (n.enumerable ? (I(e, C) && e[C][a] && (e[C][a] = !1), n = qr(n, { enumerable: Jn(0, !1) })) : (I(e, C) || sr(e, C, Jn(1, {})), e[C][a] = !0), Qn(e, a, n)) : sr(e, a, n);
}, Fa = function(e, t) {
  qn(e);
  var n = ft(t), a = Uc(n).concat(ru(n));
  return dt(a, function(o) {
    (!Ir || Na(Xc, n, o)) && $t(e, o, n[o]);
  }), e;
}, cm = function(e, t) {
  return t === void 0 ? qr(e) : Fa(qr(e), t);
}, Xc = function(e) {
  var t = ka(e), n = Na(im, this, t);
  return this === B && I(Y, t) && !I(de, t) ? !1 : n || !I(this, t) || !I(Y, t) || I(this, C) && this[C][t] ? n : !0;
}, Qc = function(e, t) {
  var n = ft(e), a = ka(t);
  if (!(n === B && I(Y, a) && !I(de, a))) {
    var o = zc(n, a);
    return o && I(Y, a) && !(I(n, C) && n[C][a]) && (o.enumerable = !0), o;
  }
}, Zc = function(e) {
  var t = qc(ft(e)), n = [];
  return dt(t, function(a) {
    !I(Y, a) && !I(Hc, a) && Jc(n, a);
  }), n;
}, ru = function(r) {
  var e = r === B, t = qc(e ? de : ft(r)), n = [];
  return dt(t, function(a) {
    I(Y, a) && (!e || I(B, a)) && Jc(n, Y[a]);
  }), n;
};
Pr || (cr = function() {
  if (Hg(Gr, this)) throw om("Symbol is not a constructor");
  var e = !arguments.length || arguments[0] === void 0 ? void 0 : Yg(arguments[0]), t = li(e), n = function(a) {
    this === B && Na(n, de, a), I(this, C) && I(this[C], t) && (this[C][t] = !1), Qn(this, t, Jn(1, a));
  };
  return Ir && Xn && Qn(B, t, { configurable: !0, set: n }), ln(t, e);
}, Gr = cr[Jr], ui(Gr, "toString", function() {
  return vi(this).tag;
}), ui(cr, "withoutSetter", function(r) {
  return ln(li(r), r);
}), Wc.f = Xc, Vc.f = $t, Jg.f = Fa, Gc.f = Qc, zg.f = Kc.f = Zc, qg.f = ru, rm.f = function(r) {
  return ln(Zg(r), r);
}, Ir && Xg(Gr, "description", {
  configurable: !0,
  get: function() {
    return vi(this).description;
  }
}));
vt({ global: !0, wrap: !0, forced: !Pr, sham: !Pr }, {
  Symbol: cr
});
dt(Uc(sm), function(r) {
  em(r);
});
vt({ target: pt, stat: !0, forced: !Pr }, {
  useSetter: function() {
    Xn = !0;
  },
  useSimple: function() {
    Xn = !1;
  }
});
vt({ target: "Object", stat: !0, forced: !Pr, sham: !Ir }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: cm,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $t,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: Fa,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: Qc
});
vt({ target: "Object", stat: !0, forced: !Pr }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: Zc
});
tm();
nm(cr, pt);
Hc[C] = !0;
var um = jr, eu = um && !!Symbol.for && !!Symbol.keyFor, lm = g, vm = M, fm = A, dm = kr, tu = oe, pm = eu, vn = tu("string-to-symbol-registry"), $m = tu("symbol-to-string-registry");
lm({ target: "Symbol", stat: !0, forced: !pm }, {
  for: function(r) {
    var e = dm(r);
    if (fm(vn, e)) return vn[e];
    var t = vm("Symbol")(e);
    return vn[e] = t, $m[t] = e, t;
  }
});
var hm = g, ym = A, gm = at, mm = ae, bm = oe, Sm = eu, fi = bm("symbol-to-string-registry");
hm({ target: "Symbol", stat: !0, forced: !Sm }, {
  keyFor: function(e) {
    if (!gm(e)) throw TypeError(mm(e) + " is not a symbol");
    if (ym(fi, e)) return fi[e];
  }
});
var Om = w, La = Om([].slice), _m = w, di = lt, Tm = T, pi = vr, Em = kr, $i = _m([].push), wm = function(r) {
  if (Tm(r)) return r;
  if (di(r)) {
    for (var e = r.length, t = [], n = 0; n < e; n++) {
      var a = r[n];
      typeof a == "string" ? $i(t, a) : (typeof a == "number" || pi(a) === "Number" || pi(a) === "String") && $i(t, Em(a));
    }
    var o = t.length, i = !0;
    return function(s, u) {
      if (i)
        return i = !1, u;
      if (di(this)) return u;
      for (var l = 0; l < o; l++) if (t[l] === s) return u;
    };
  }
}, Im = g, nu = M, au = ha, Pm = R, pe = w, ou = O, hi = T, yi = at, iu = La, Rm = wm, Cm = jr, Am = String, X = nu("JSON", "stringify"), Re = pe(/./.exec), gi = pe("".charAt), Dm = pe("".charCodeAt), jm = pe("".replace), xm = pe(1 .toString), Nm = /[\uD800-\uDFFF]/g, mi = /^[\uD800-\uDBFF]$/, bi = /^[\uDC00-\uDFFF]$/, Si = !Cm || ou(function() {
  var r = nu("Symbol")("stringify detection");
  return X([r]) !== "[null]" || X({ a: r }) !== "{}" || X(Object(r)) !== "{}";
}), Oi = ou(function() {
  return X("\uDF06\uD834") !== '"\\udf06\\ud834"' || X("\uDEAD") !== '"\\udead"';
}), km = function(r, e) {
  var t = iu(arguments), n = Rm(e);
  if (!(!hi(n) && (r === void 0 || yi(r))))
    return t[1] = function(a, o) {
      if (hi(n) && (o = Pm(n, this, Am(a), o)), !yi(o)) return o;
    }, au(X, null, t);
}, Mm = function(r, e, t) {
  var n = gi(t, e - 1), a = gi(t, e + 1);
  return Re(mi, r) && !Re(bi, a) || Re(bi, r) && !Re(mi, n) ? "\\u" + xm(Dm(r, 0), 16) : r;
};
X && Im({ target: "JSON", stat: !0, forced: Si || Oi }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(e, t, n) {
    var a = iu(arguments), o = au(Si ? km : X, null, a);
    return Oi && typeof o == "string" ? jm(o, Nm, Mm) : o;
  }
});
var Fm = g, Lm = jr, Bm = O, su = ue, Um = xr, Km = !Lm || Bm(function() {
  su.f(1);
});
Fm({ target: "Object", stat: !0, forced: Km }, {
  getOwnPropertySymbols: function(e) {
    var t = su.f;
    return t ? t(Um(e)) : [];
  }
});
var Gm = k;
Gm.Object.getOwnPropertySymbols;
var Vm = g, Wm = O, Hm = q, cu = Dr.f, uu = x, Ym = !uu || Wm(function() {
  cu(1);
});
Vm({ target: "Object", stat: !0, forced: Ym, sham: !uu }, {
  getOwnPropertyDescriptor: function(e, t) {
    return cu(Hm(e), t);
  }
});
var zm = k, qm = zm.Object;
qm.getOwnPropertyDescriptor.sham;
var Jm = g, Xm = x, _i = U.f;
Jm({ target: "Object", stat: !0, forced: Object.defineProperty !== _i, sham: !Xm }, {
  defineProperty: _i
});
var Qm = k, Zm = Qm.Object;
Zm.defineProperty.sham;
var rb = O, eb = !rb(function() {
  function r() {
  }
  return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
}), tb = A, nb = T, ab = xr, ob = st, ib = eb, Ti = ob("IE_PROTO"), Zn = Object, sb = Zn.prototype, Ba = ib ? Zn.getPrototypeOf : function(r) {
  var e = ab(r);
  if (tb(e, Ti)) return e[Ti];
  var t = e.constructor;
  return nb(t) && e instanceof t ? t.prototype : e instanceof Zn ? sb : null;
}, cb = M, ub = w, lb = ct, vb = ue, fb = K, db = ub([].concat), pb = cb("Reflect", "ownKeys") || function(e) {
  var t = lb.f(fb(e)), n = vb.f;
  return n ? db(t, n(e)) : t;
}, Ei = A, $b = pb, hb = Dr, yb = U, gb = function(r, e, t) {
  for (var n = $b(e), a = yb.f, o = hb.f, i = 0; i < n.length; i++) {
    var s = n[i];
    !Ei(r, s) && !(t && Ei(t, s)) && a(r, s, o(e, s));
  }
}, mb = N, bb = tr, Sb = function(r, e) {
  mb(e) && "cause" in e && bb(r, "cause", e.cause);
}, Ob = w, lu = Error, _b = Ob("".replace), Tb = function(r) {
  return String(lu(r).stack);
}("zxcasd"), vu = /\n\s*at [^:]*:[^\n]*/, Eb = vu.test(Tb), wb = function(r, e) {
  if (Eb && typeof r == "string" && !lu.prepareStackTrace)
    for (; e--; ) r = _b(r, vu, "");
  return r;
}, Ib = O, Pb = fr, Rb = !Ib(function() {
  var r = Error("a");
  return "stack" in r ? (Object.defineProperty(r, "stack", Pb(1, 7)), r.stack !== 7) : !0;
}), Cb = tr, Ab = wb, Db = Rb, wi = Error.captureStackTrace, jb = function(r, e, t, n) {
  Db && (wi ? wi(r, e) : Cb(r, "stack", Ab(t, n)));
}, Fr = {}, xb = _, Nb = Fr, kb = xb("iterator"), Mb = Array.prototype, Fb = function(r) {
  return r !== void 0 && (Nb.Array === r || Mb[kb] === r);
}, Lb = le, Ii = ba, Bb = et, Ub = Fr, Kb = _, Gb = Kb("iterator"), fu = function(r) {
  if (!Bb(r)) return Ii(r, Gb) || Ii(r, "@@iterator") || Ub[Lb(r)];
}, Vb = R, Wb = V, Hb = K, Yb = ae, zb = fu, qb = TypeError, Jb = function(r, e) {
  var t = arguments.length < 2 ? zb(r) : e;
  if (Wb(t)) return Hb(Vb(t, r));
  throw qb(Yb(r) + " is not iterable");
}, Xb = R, Pi = K, Qb = ba, Zb = function(r, e, t) {
  var n, a;
  Pi(r);
  try {
    if (n = Qb(r, "return"), !n) {
      if (e === "throw") throw t;
      return t;
    }
    n = Xb(n, r);
  } catch (o) {
    a = !0, n = o;
  }
  if (e === "throw") throw t;
  if (a) throw n;
  return Pi(n), t;
}, rS = se, eS = R, tS = K, nS = ae, aS = Fb, oS = Nr, Ri = ne, iS = Jb, sS = fu, Ci = Zb, cS = TypeError, Ue = function(r, e) {
  this.stopped = r, this.result = e;
}, Ai = Ue.prototype, $e = function(r, e, t) {
  var n = t && t.that, a = !!(t && t.AS_ENTRIES), o = !!(t && t.IS_RECORD), i = !!(t && t.IS_ITERATOR), s = !!(t && t.INTERRUPTED), u = rS(e, n), l, c, f, v, d, $, h, p = function(b) {
    return l && Ci(l, "normal", b), new Ue(!0, b);
  }, y = function(b) {
    return a ? (tS(b), s ? u(b[0], b[1], p) : u(b[0], b[1])) : s ? u(b, p) : u(b);
  };
  if (o)
    l = r.iterator;
  else if (i)
    l = r;
  else {
    if (c = sS(r), !c) throw cS(nS(r) + " is not iterable");
    if (aS(c)) {
      for (f = 0, v = oS(r); v > f; f++)
        if (d = y(r[f]), d && Ri(Ai, d)) return d;
      return new Ue(!1);
    }
    l = iS(r, c);
  }
  for ($ = o ? r.next : l.next; !(h = eS($, l)).done; ) {
    try {
      d = y(h.value);
    } catch (b) {
      Ci(l, "throw", b);
    }
    if (typeof d == "object" && d && Ri(Ai, d)) return d;
  }
  return new Ue(!1);
}, uS = kr, lS = function(r, e) {
  return r === void 0 ? arguments.length < 2 ? "" : e : uS(r);
}, vS = g, fS = ne, dS = Ba, ze = Sc, pS = gb, du = ce, fn = tr, dn = fr, $S = Sb, hS = jb, yS = $e, gS = lS, mS = _, bS = mS("toStringTag"), qe = Error, SS = [].push, Rr = function(e, t) {
  var n = fS(pn, this), a;
  ze ? a = ze(qe(), n ? dS(this) : pn) : (a = n ? this : du(pn), fn(a, bS, "Error")), t !== void 0 && fn(a, "message", gS(t)), hS(a, Rr, a.stack, 1), arguments.length > 2 && $S(a, arguments[2]);
  var o = [];
  return yS(e, SS, { that: o }), fn(a, "errors", o), a;
};
ze ? ze(Rr, qe) : pS(Rr, qe, { name: !0 });
var pn = Rr.prototype = du(qe.prototype, {
  constructor: dn(1, Rr),
  message: dn(1, ""),
  name: dn(1, "AggregateError")
});
vS({ global: !0 }, {
  AggregateError: Rr
});
var ra = x, OS = A, pu = Function.prototype, _S = ra && Object.getOwnPropertyDescriptor, $u = OS(pu, "name"), TS = $u && (function() {
}).name === "something";
$u && (!ra || ra && _S(pu, "name").configurable);
var ES = {
  PROPER: TS
}, wS = O, IS = T, PS = N, RS = ce, Di = Ba, CS = ve, AS = _, ea = AS("iterator"), hu = !1, H, $n, hn;
[].keys && (hn = [].keys(), "next" in hn ? ($n = Di(Di(hn)), $n !== Object.prototype && (H = $n)) : hu = !0);
var DS = !PS(H) || wS(function() {
  var r = {};
  return H[ea].call(r) !== r;
});
DS ? H = {} : H = RS(H);
IS(H[ea]) || CS(H, ea, function() {
  return this;
});
var yu = {
  IteratorPrototype: H,
  BUGGY_SAFARI_ITERATORS: hu
}, jS = yu.IteratorPrototype, xS = ce, NS = fr, kS = Mr, MS = Fr, FS = function() {
  return this;
}, LS = function(r, e, t, n) {
  var a = e + " Iterator";
  return r.prototype = xS(jS, { next: NS(+!n, t) }), kS(r, a, !1, !0), MS[a] = FS, r;
}, BS = g, US = R, KS = ES, GS = LS, VS = Ba, WS = Mr, ji = ve, HS = _, xi = Fr, YS = yu, zS = KS.PROPER, Ce = YS.BUGGY_SAFARI_ITERATORS, yn = HS("iterator"), Ni = "keys", Ae = "values", ki = "entries", qS = function() {
  return this;
}, gu = function(r, e, t, n, a, o, i) {
  GS(t, e, n);
  var s = function(y) {
    if (y === a && v) return v;
    if (!Ce && y in c) return c[y];
    switch (y) {
      case Ni:
        return function() {
          return new t(this, y);
        };
      case Ae:
        return function() {
          return new t(this, y);
        };
      case ki:
        return function() {
          return new t(this, y);
        };
    }
    return function() {
      return new t(this);
    };
  }, u = e + " Iterator", l = !1, c = r.prototype, f = c[yn] || c["@@iterator"] || a && c[a], v = !Ce && f || s(a), d = e === "Array" && c.entries || f, $, h, p;
  if (d && ($ = VS(d.call(new r())), $ !== Object.prototype && $.next && (WS($, u, !0, !0), xi[u] = qS)), zS && a === Ae && f && f.name !== Ae && (l = !0, v = function() {
    return US(f, this);
  }), a)
    if (h = {
      values: s(Ae),
      keys: o ? v : s(Ni),
      entries: s(ki)
    }, i) for (p in h)
      (Ce || l || !(p in c)) && ji(c, p, h[p]);
    else BS({ target: e, proto: !0, forced: Ce || l }, h);
  return i && c[yn] !== v && ji(c, yn, v, {}), xi[e] = v, h;
}, mu = function(r, e) {
  return { value: r, done: e };
}, JS = q, Mi = Fr, bu = ut;
U.f;
var XS = gu, De = mu, Su = "Array Iterator", QS = bu.set, ZS = bu.getterFor(Su);
XS(Array, "Array", function(r, e) {
  QS(this, {
    type: Su,
    target: JS(r),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var r = ZS(this), e = r.target, t = r.kind, n = r.index++;
  if (!e || n >= e.length)
    return r.target = void 0, De(void 0, !0);
  switch (t) {
    case "keys":
      return De(n, !1);
    case "values":
      return De(e[n], !1);
  }
  return De([n, e[n]], !1);
}, "values");
Mi.Arguments = Mi.Array;
var rO = E, eO = vr, ht = eO(rO.process) === "process", tO = M, nO = Dc, aO = _, oO = x, Fi = aO("species"), iO = function(r) {
  var e = tO(r);
  oO && e && !e[Fi] && nO(e, Fi, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, sO = ne, cO = TypeError, uO = function(r, e) {
  if (sO(e, r)) return r;
  throw cO("Incorrect invocation");
}, lO = ja, vO = ae, fO = TypeError, dO = function(r) {
  if (lO(r)) return r;
  throw fO(vO(r) + " is not a constructor");
}, Li = K, pO = dO, $O = et, hO = _, yO = hO("species"), Ou = function(r, e) {
  var t = Li(r).constructor, n;
  return t === void 0 || $O(n = Li(t)[yO]) ? e : pO(n);
}, gO = TypeError, mO = function(r, e) {
  if (r < e) throw gO("Not enough arguments");
  return r;
}, bO = tt, _u = /(?:ipad|iphone|ipod).*applewebkit/i.test(bO), j = E, SO = ha, OO = se, Bi = T, _O = A, Tu = O, Ui = Tc, TO = La, Ki = _a, EO = mO, wO = _u, IO = ht, ta = j.setImmediate, Gi = j.clearImmediate, PO = j.process, gn = j.Dispatch, RO = j.Function, Vi = j.MessageChannel, CO = j.String, mn = 0, Vr = {}, Wi = "onreadystatechange", Xr, ar, bn, Sn;
Tu(function() {
  Xr = j.location;
});
var Ua = function(r) {
  if (_O(Vr, r)) {
    var e = Vr[r];
    delete Vr[r], e();
  }
}, On = function(r) {
  return function() {
    Ua(r);
  };
}, Hi = function(r) {
  Ua(r.data);
}, Yi = function(r) {
  j.postMessage(CO(r), Xr.protocol + "//" + Xr.host);
};
(!ta || !Gi) && (ta = function(e) {
  EO(arguments.length, 1);
  var t = Bi(e) ? e : RO(e), n = TO(arguments, 1);
  return Vr[++mn] = function() {
    SO(t, void 0, n);
  }, ar(mn), mn;
}, Gi = function(e) {
  delete Vr[e];
}, IO ? ar = function(r) {
  PO.nextTick(On(r));
} : gn && gn.now ? ar = function(r) {
  gn.now(On(r));
} : Vi && !wO ? (bn = new Vi(), Sn = bn.port2, bn.port1.onmessage = Hi, ar = OO(Sn.postMessage, Sn)) : j.addEventListener && Bi(j.postMessage) && !j.importScripts && Xr && Xr.protocol !== "file:" && !Tu(Yi) ? (ar = Yi, j.addEventListener("message", Hi, !1)) : Wi in Ki("script") ? ar = function(r) {
  Ui.appendChild(Ki("script"))[Wi] = function() {
    Ui.removeChild(this), Ua(r);
  };
} : ar = function(r) {
  setTimeout(On(r), 0);
});
var Eu = {
  set: ta
}, wu = function() {
  this.head = null, this.tail = null;
};
wu.prototype = {
  add: function(r) {
    var e = { item: r, next: null }, t = this.tail;
    t ? t.next = e : this.head = e, this.tail = e;
  },
  get: function() {
    var r = this.head;
    if (r) {
      var e = this.head = r.next;
      return e === null && (this.tail = null), r.item;
    }
  }
};
var Iu = wu, AO = tt, DO = /ipad|iphone|ipod/i.test(AO) && typeof Pebble < "u", jO = tt, xO = /web0s(?!.*chrome)/i.test(jO), ur = E, zi = se, NO = Dr.f, _n = Eu.set, kO = Iu, MO = _u, FO = DO, LO = xO, Tn = ht, qi = ur.MutationObserver || ur.WebKitMutationObserver, Ji = ur.document, Xi = ur.process, je = ur.Promise, Qi = NO(ur, "queueMicrotask"), na = Qi && Qi.value, mr, En, wn, xe, Zi;
if (!na) {
  var Ne = new kO(), ke = function() {
    var r, e;
    for (Tn && (r = Xi.domain) && r.exit(); e = Ne.get(); ) try {
      e();
    } catch (t) {
      throw Ne.head && mr(), t;
    }
    r && r.enter();
  };
  !MO && !Tn && !LO && qi && Ji ? (En = !0, wn = Ji.createTextNode(""), new qi(ke).observe(wn, { characterData: !0 }), mr = function() {
    wn.data = En = !En;
  }) : !FO && je && je.resolve ? (xe = je.resolve(void 0), xe.constructor = je, Zi = zi(xe.then, xe), mr = function() {
    Zi(ke);
  }) : Tn ? mr = function() {
    Xi.nextTick(ke);
  } : (_n = zi(_n, ur), mr = function() {
    _n(ke);
  }), na = function(r) {
    Ne.head || mr(), Ne.add(r);
  };
}
var BO = na, UO = function(r, e) {
  try {
    arguments.length === 1 ? console.error(r) : console.error(r, e);
  } catch {
  }
}, he = function(r) {
  try {
    return { error: !1, value: r() };
  } catch (e) {
    return { error: !0, value: e };
  }
}, KO = E, Lr = KO.Promise, Pu = typeof Deno == "object" && Deno && typeof Deno.version == "object", GO = Pu, VO = ht, WO = !GO && !VO && typeof window == "object" && typeof document == "object", HO = E, Wr = Lr, YO = T, zO = mc, qO = Nc, JO = _, XO = WO, QO = Pu, In = nt, rs = Wr && Wr.prototype, ZO = JO("species"), es = !1, Ru = YO(HO.PromiseRejectionEvent), r1 = zO("Promise", function() {
  var r = qO(Wr), e = r !== String(Wr);
  if (!e && In === 66 || !(rs.catch && rs.finally)) return !0;
  if (!In || In < 51 || !/native code/.test(r)) {
    var t = new Wr(function(o) {
      o(1);
    }), n = function(o) {
      o(function() {
      }, function() {
      });
    }, a = t.constructor = {};
    if (a[ZO] = n, es = t.then(function() {
    }) instanceof n, !es) return !0;
  }
  return !e && (XO || QO) && !Ru;
}), ye = {
  CONSTRUCTOR: r1,
  REJECTION_EVENT: Ru
}, nr = {}, ts = V, e1 = TypeError, t1 = function(r) {
  var e, t;
  this.promise = new r(function(n, a) {
    if (e !== void 0 || t !== void 0) throw e1("Bad Promise constructor");
    e = n, t = a;
  }), this.resolve = ts(e), this.reject = ts(t);
};
nr.f = function(r) {
  return new t1(r);
};
var n1 = g, Je = ht, Q = E, ge = R, a1 = ve, o1 = Mr, i1 = iO, s1 = V, aa = T, c1 = N, u1 = uO, l1 = Ou, Cu = Eu.set, Ka = BO, v1 = UO, f1 = he, d1 = Iu, Au = ut, oa = Lr, Du = ye, ju = nr, yt = "Promise", xu = Du.CONSTRUCTOR, p1 = Du.REJECTION_EVENT, Pn = Au.getterFor(yt), $1 = Au.set, h1 = oa && oa.prototype, Or = oa, Rn = h1, Nu = Q.TypeError, ia = Q.document, Ga = Q.process, sa = ju.f, y1 = sa, g1 = !!(ia && ia.createEvent && Q.dispatchEvent), ku = "unhandledrejection", m1 = "rejectionhandled", ns = 0, Mu = 1, b1 = 2, Va = 1, Fu = 2, Me, as, S1, Lu = function(r) {
  var e;
  return c1(r) && aa(e = r.then) ? e : !1;
}, Bu = function(r, e) {
  var t = e.value, n = e.state === Mu, a = n ? r.ok : r.fail, o = r.resolve, i = r.reject, s = r.domain, u, l, c;
  try {
    a ? (n || (e.rejection === Fu && _1(e), e.rejection = Va), a === !0 ? u = t : (s && s.enter(), u = a(t), s && (s.exit(), c = !0)), u === r.promise ? i(Nu("Promise-chain cycle")) : (l = Lu(u)) ? ge(l, u, o, i) : o(u)) : i(t);
  } catch (f) {
    s && !c && s.exit(), i(f);
  }
}, Uu = function(r, e) {
  r.notified || (r.notified = !0, Ka(function() {
    for (var t = r.reactions, n; n = t.get(); )
      Bu(n, r);
    r.notified = !1, e && !r.rejection && O1(r);
  }));
}, Ku = function(r, e, t) {
  var n, a;
  g1 ? (n = ia.createEvent("Event"), n.promise = e, n.reason = t, n.initEvent(r, !1, !0), Q.dispatchEvent(n)) : n = { promise: e, reason: t }, !p1 && (a = Q["on" + r]) ? a(n) : r === ku && v1("Unhandled promise rejection", t);
}, O1 = function(r) {
  ge(Cu, Q, function() {
    var e = r.facade, t = r.value, n = os(r), a;
    if (n && (a = f1(function() {
      Je ? Ga.emit("unhandledRejection", t, e) : Ku(ku, e, t);
    }), r.rejection = Je || os(r) ? Fu : Va, a.error))
      throw a.value;
  });
}, os = function(r) {
  return r.rejection !== Va && !r.parent;
}, _1 = function(r) {
  ge(Cu, Q, function() {
    var e = r.facade;
    Je ? Ga.emit("rejectionHandled", e) : Ku(m1, e, r.value);
  });
}, _r = function(r, e, t) {
  return function(n) {
    r(e, n, t);
  };
}, Tr = function(r, e, t) {
  r.done || (r.done = !0, t && (r = t), r.value = e, r.state = b1, Uu(r, !0));
}, ca = function(r, e, t) {
  if (!r.done) {
    r.done = !0, t && (r = t);
    try {
      if (r.facade === e) throw Nu("Promise can't be resolved itself");
      var n = Lu(e);
      n ? Ka(function() {
        var a = { done: !1 };
        try {
          ge(
            n,
            e,
            _r(ca, a, r),
            _r(Tr, a, r)
          );
        } catch (o) {
          Tr(a, o, r);
        }
      }) : (r.value = e, r.state = Mu, Uu(r, !1));
    } catch (a) {
      Tr({ done: !1 }, a, r);
    }
  }
};
xu && (Or = function(e) {
  u1(this, Rn), s1(e), ge(Me, this);
  var t = Pn(this);
  try {
    e(_r(ca, t), _r(Tr, t));
  } catch (n) {
    Tr(t, n);
  }
}, Rn = Or.prototype, Me = function(e) {
  $1(this, {
    type: yt,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new d1(),
    rejection: !1,
    state: ns,
    value: void 0
  });
}, Me.prototype = a1(Rn, "then", function(e, t) {
  var n = Pn(this), a = sa(l1(this, Or));
  return n.parent = !0, a.ok = aa(e) ? e : !0, a.fail = aa(t) && t, a.domain = Je ? Ga.domain : void 0, n.state === ns ? n.reactions.add(a) : Ka(function() {
    Bu(a, n);
  }), a.promise;
}), as = function() {
  var r = new Me(), e = Pn(r);
  this.promise = r, this.resolve = _r(ca, e), this.reject = _r(Tr, e);
}, ju.f = sa = function(r) {
  return r === Or || r === S1 ? new as(r) : y1(r);
});
n1({ global: !0, wrap: !0, forced: xu }, {
  Promise: Or
});
o1(Or, yt, !1, !0);
i1(yt);
var T1 = _, Gu = T1("iterator"), Vu = !1;
try {
  var E1 = 0, is = {
    next: function() {
      return { done: !!E1++ };
    },
    return: function() {
      Vu = !0;
    }
  };
  is[Gu] = function() {
    return this;
  }, Array.from(is, function() {
    throw 2;
  });
} catch {
}
var w1 = function(r, e) {
  if (!e && !Vu) return !1;
  var t = !1;
  try {
    var n = {};
    n[Gu] = function() {
      return {
        next: function() {
          return { done: t = !0 };
        }
      };
    }, r(n);
  } catch {
  }
  return t;
}, I1 = Lr, P1 = w1, R1 = ye.CONSTRUCTOR, gt = R1 || !P1(function(r) {
  I1.all(r).then(void 0, function() {
  });
}), C1 = g, A1 = R, D1 = V, j1 = nr, x1 = he, N1 = $e, k1 = gt;
C1({ target: "Promise", stat: !0, forced: k1 }, {
  all: function(e) {
    var t = this, n = j1.f(t), a = n.resolve, o = n.reject, i = x1(function() {
      var s = D1(t.resolve), u = [], l = 0, c = 1;
      N1(e, function(f) {
        var v = l++, d = !1;
        c++, A1(s, t, f).then(function($) {
          d || (d = !0, u[v] = $, --c || a(u));
        }, o);
      }), --c || a(u);
    });
    return i.error && o(i.value), n.promise;
  }
});
var M1 = g, F1 = ye.CONSTRUCTOR, ss = Lr;
ss && ss.prototype;
M1({ target: "Promise", proto: !0, forced: F1, real: !0 }, {
  catch: function(r) {
    return this.then(void 0, r);
  }
});
var L1 = g, B1 = R, U1 = V, K1 = nr, G1 = he, V1 = $e, W1 = gt;
L1({ target: "Promise", stat: !0, forced: W1 }, {
  race: function(e) {
    var t = this, n = K1.f(t), a = n.reject, o = G1(function() {
      var i = U1(t.resolve);
      V1(e, function(s) {
        B1(i, t, s).then(n.resolve, a);
      });
    });
    return o.error && a(o.value), n.promise;
  }
});
var H1 = g, Y1 = R, z1 = nr, q1 = ye.CONSTRUCTOR;
H1({ target: "Promise", stat: !0, forced: q1 }, {
  reject: function(e) {
    var t = z1.f(this);
    return Y1(t.reject, void 0, e), t.promise;
  }
});
var J1 = K, X1 = N, Q1 = nr, Wu = function(r, e) {
  if (J1(r), X1(e) && e.constructor === r) return e;
  var t = Q1.f(r), n = t.resolve;
  return n(e), t.promise;
}, Z1 = g, r_ = M, e_ = Ap, t_ = Lr, n_ = ye.CONSTRUCTOR, a_ = Wu, o_ = r_("Promise"), i_ = !n_;
Z1({ target: "Promise", stat: !0, forced: e_ }, {
  resolve: function(e) {
    return a_(i_ && this === o_ ? t_ : this, e);
  }
});
var s_ = g, c_ = R, u_ = V, l_ = nr, v_ = he, f_ = $e, d_ = gt;
s_({ target: "Promise", stat: !0, forced: d_ }, {
  allSettled: function(e) {
    var t = this, n = l_.f(t), a = n.resolve, o = n.reject, i = v_(function() {
      var s = u_(t.resolve), u = [], l = 0, c = 1;
      f_(e, function(f) {
        var v = l++, d = !1;
        c++, c_(s, t, f).then(function($) {
          d || (d = !0, u[v] = { status: "fulfilled", value: $ }, --c || a(u));
        }, function($) {
          d || (d = !0, u[v] = { status: "rejected", reason: $ }, --c || a(u));
        });
      }), --c || a(u);
    });
    return i.error && o(i.value), n.promise;
  }
});
var p_ = g, $_ = R, h_ = V, y_ = M, g_ = nr, m_ = he, b_ = $e, S_ = gt, cs = "No one promise resolved";
p_({ target: "Promise", stat: !0, forced: S_ }, {
  any: function(e) {
    var t = this, n = y_("AggregateError"), a = g_.f(t), o = a.resolve, i = a.reject, s = m_(function() {
      var u = h_(t.resolve), l = [], c = 0, f = 1, v = !1;
      b_(e, function(d) {
        var $ = c++, h = !1;
        f++, $_(u, t, d).then(function(p) {
          h || v || (v = !0, o(p));
        }, function(p) {
          h || v || (h = !0, l[$] = p, --f || i(new n(l, cs)));
        });
      }), --f || i(new n(l, cs));
    });
    return s.error && i(s.value), a.promise;
  }
});
var O_ = g, ua = Lr, __ = O, T_ = M, E_ = T, w_ = Ou, us = Wu, I_ = ua && ua.prototype, P_ = !!ua && __(function() {
  I_.finally.call({ then: function() {
  } }, function() {
  });
});
O_({ target: "Promise", proto: !0, real: !0, forced: P_ }, {
  finally: function(r) {
    var e = w_(this, T_("Promise")), t = E_(r);
    return this.then(
      t ? function(n) {
        return us(e, r()).then(function() {
          return n;
        });
      } : r,
      t ? function(n) {
        return us(e, r()).then(function() {
          throw n;
        });
      } : r
    );
  }
});
var Wa = w, R_ = Ea, C_ = kr, A_ = ma, D_ = Wa("".charAt), ls = Wa("".charCodeAt), j_ = Wa("".slice), x_ = function(r) {
  return function(e, t) {
    var n = C_(A_(e)), a = R_(t), o = n.length, i, s;
    return a < 0 || a >= o ? r ? "" : void 0 : (i = ls(n, a), i < 55296 || i > 56319 || a + 1 === o || (s = ls(n, a + 1)) < 56320 || s > 57343 ? r ? D_(n, a) : i : r ? j_(n, a, a + 2) : (i - 55296 << 10) + (s - 56320) + 65536);
  };
}, N_ = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: x_(!0)
}, k_ = N_.charAt, M_ = kr, Hu = ut, F_ = gu, vs = mu, Yu = "String Iterator", L_ = Hu.set, B_ = Hu.getterFor(Yu);
F_(String, "String", function(r) {
  L_(this, {
    type: Yu,
    string: M_(r),
    index: 0
  });
}, function() {
  var e = B_(this), t = e.string, n = e.index, a;
  return n >= t.length ? vs(void 0, !0) : (a = k_(t, n), e.index += a.length, vs(a, !1));
});
var U_ = k, K_ = U_.Promise, G_ = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, V_ = G_, W_ = E, H_ = le, Y_ = tr, fs = Fr, z_ = _, ds = z_("toStringTag");
for (var Cn in V_) {
  var ps = W_[Cn], An = ps && ps.prototype;
  An && H_(An) !== ds && Y_(An, ds, Cn), fs[Cn] = fs.Array;
}
var q_ = K_, J_ = q_, X_ = J_, Q_ = /* @__PURE__ */ Vd(X_), Z_ = TypeError, rT = 9007199254740991, eT = function(r) {
  if (r > rT) throw Z_("Maximum allowed index exceeded");
  return r;
}, tT = O, nT = _, aT = nt, oT = nT("species"), zu = function(r) {
  return aT >= 51 || !tT(function() {
    var e = [], t = e.constructor = {};
    return t[oT] = function() {
      return { foo: 1 };
    }, e[r](Boolean).foo !== 1;
  });
}, iT = g, sT = O, cT = lt, uT = N, lT = xr, vT = Nr, $s = eT, hs = Aa, fT = Bc, dT = zu, pT = _, $T = nt, qu = pT("isConcatSpreadable"), hT = $T >= 51 || !sT(function() {
  var r = [];
  return r[qu] = !1, r.concat()[0] !== r;
}), yT = function(r) {
  if (!uT(r)) return !1;
  var e = r[qu];
  return e !== void 0 ? !!e : cT(r);
}, gT = !hT || !dT("concat");
iT({ target: "Array", proto: !0, forced: gT }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(e) {
    var t = lT(this), n = fT(t, 0), a = 0, o, i, s, u, l;
    for (o = -1, s = arguments.length; o < s; o++)
      if (l = o === -1 ? t : arguments[o], yT(l))
        for (u = vT(l), $s(a + u), i = 0; i < u; i++, a++) i in l && hs(n, a, l[i]);
      else
        $s(a + 1), hs(n, a++, l);
    return n.length = a, n;
  }
});
var mT = D;
mT("asyncIterator");
var bT = D;
bT("hasInstance");
var ST = D;
ST("isConcatSpreadable");
var OT = D;
OT("iterator");
var _T = D;
_T("match");
var TT = D;
TT("matchAll");
var ET = D;
ET("replace");
var wT = D;
wT("search");
var IT = D;
IT("species");
var PT = D;
PT("split");
var RT = D, CT = jc;
RT("toPrimitive");
CT();
var AT = M, DT = D, jT = Mr;
DT("toStringTag");
jT(AT("Symbol"), "Symbol");
var xT = D;
xT("unscopables");
var NT = E, kT = Mr;
kT(NT.JSON, "JSON", !0);
var MT = k;
MT.Symbol;
var FT = fe;
FT.f("iterator");
var LT = Ra;
LT("Array").concat;
var BT = g, ys = lt, UT = ja, KT = N, gs = wa, GT = Nr, VT = q, WT = Aa, HT = _, YT = zu, zT = La, qT = YT("slice"), JT = HT("species"), Dn = Array, XT = Math.max;
BT({ target: "Array", proto: !0, forced: !qT }, {
  slice: function(e, t) {
    var n = VT(this), a = GT(n), o = gs(e, a), i = gs(t === void 0 ? a : t, a), s, u, l;
    if (ys(n) && (s = n.constructor, UT(s) && (s === Dn || ys(s.prototype)) ? s = void 0 : KT(s) && (s = s[JT], s === null && (s = void 0)), s === Dn || s === void 0))
      return zT(n, o, i);
    for (u = new (s === void 0 ? Dn : s)(XT(i - o, 0)), l = 0; o < i; o++, l++) o in n && WT(u, l, n[o]);
    return u.length = l, u;
  }
});
var QT = Ra;
QT("Array").slice;
var ZT = fe;
ZT.f("asyncIterator");
function jn(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = Q_))(function(o, i) {
    function s(c) {
      try {
        l(n.next(c));
      } catch (f) {
        i(f);
      }
    }
    function u(c) {
      try {
        l(n.throw(c));
      } catch (f) {
        i(f);
      }
    }
    function l(c) {
      c.done ? o(c.value) : a(c.value).then(s, u);
    }
    l((n = n.apply(r, [])).next());
  });
}
class rE {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    var e;
    return window.electron ? !!window.electron : !!(!((e = process == null ? void 0 : process.versions) === null || e === void 0) && e.electron) || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  getVersion() {
    return jn(this, void 0, void 0, function* () {
      return window.electron ? (yield window.electron.getVersion()).split("-")[0] : "0.0.0";
    });
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  isStandaloneBuild() {
    return jn(this, void 0, void 0, function* () {
      var e;
      return !((e = window.electron) === null || e === void 0) && e.isStandaloneBuild ? yield window.electron.isStandaloneBuild() : null;
    });
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  isMsiBuild() {
    return jn(this, void 0, void 0, function* () {
      var e;
      return !((e = window.electron) === null || e === void 0) && e.isMsiBuild ? yield window.electron.isMsiBuild() : null;
    });
  }
}
const ms = new rE();
function eE(r, e) {
  return bs(r), bs(e), r.localeCompare(e, void 0, {
    numeric: !0
  });
}
function bs(r) {
  if (r.split(".").length !== 3)
    throw Error(`The version '${r}' must be in the format 'x.x.x'.`);
}
const tE = Object.prototype.toString;
function nE(r, e) {
  return tE.call(r) === `[object ${e}]`;
}
function aE(r) {
  return nE(r, "Object");
}
function oE(r) {
  return !!(r && r.then && typeof r.then == "function");
}
const Hr = "8.36.0", z = globalThis;
function Ha(r, e, t) {
  const n = t || z, a = n.__SENTRY__ = n.__SENTRY__ || {}, o = a[Hr] = a[Hr] || {};
  return o[r] || (o[r] = e());
}
const Ju = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, iE = "Sentry Logger ", Ss = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Os = {};
function Xu(r) {
  if (!("console" in z))
    return r();
  const e = z.console, t = {}, n = Object.keys(Os);
  n.forEach((a) => {
    const o = Os[a];
    t[a] = e[a], e[a] = o;
  });
  try {
    return r();
  } finally {
    n.forEach((a) => {
      e[a] = t[a];
    });
  }
}
function sE() {
  let r = !1;
  const e = {
    enable: () => {
      r = !0;
    },
    disable: () => {
      r = !1;
    },
    isEnabled: () => r
  };
  return Ju ? Ss.forEach((t) => {
    e[t] = (...n) => {
      r && Xu(() => {
        z.console[t](`${iE}[${t}]:`, ...n);
      });
    };
  }) : Ss.forEach((t) => {
    e[t] = () => {
    };
  }), e;
}
const Ke = Ha("logger", sE);
function cE(r, e, t) {
  try {
    Object.defineProperty(r, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    Ju && Ke.log(`Failed to add non-enumerable property "${e}" to object`, r);
  }
}
const Qu = 1e3;
function Ya() {
  return Date.now() / Qu;
}
function uE() {
  const { performance: r } = z;
  if (!r || !r.now)
    return Ya;
  const e = Date.now() - r.now(), t = r.timeOrigin == null ? e : r.timeOrigin;
  return () => (t + r.now()) / Qu;
}
const lE = uE();
(() => {
  const { performance: r } = z;
  if (!r || !r.now)
    return;
  const e = 3600 * 1e3, t = r.now(), n = Date.now(), a = r.timeOrigin ? Math.abs(r.timeOrigin + t - n) : e, o = a < e, i = r.timing && r.timing.navigationStart, u = typeof i == "number" ? Math.abs(i + t - n) : e, l = u < e;
  return o || l ? a <= u ? r.timeOrigin : i : n;
})();
function Er() {
  const r = z, e = r.crypto || r.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (t = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (t() & 15) >> n / 4).toString(16)
    )
  );
}
function _s() {
  return {
    traceId: Er(),
    spanId: Er().substring(16)
  };
}
function za() {
  return qa(z), z;
}
function qa(r) {
  const e = r.__SENTRY__ = r.__SENTRY__ || {};
  return e.version = e.version || Hr, e[Hr] = e[Hr] || {};
}
function vE(r, e = {}) {
  if (e.user && (!r.ipAddress && e.user.ip_address && (r.ipAddress = e.user.ip_address), !r.did && !e.did && (r.did = e.user.id || e.user.email || e.user.username)), r.timestamp = e.timestamp || lE(), e.abnormal_mechanism && (r.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (r.ignoreDuration = e.ignoreDuration), e.sid && (r.sid = e.sid.length === 32 ? e.sid : Er()), e.init !== void 0 && (r.init = e.init), !r.did && e.did && (r.did = `${e.did}`), typeof e.started == "number" && (r.started = e.started), r.ignoreDuration)
    r.duration = void 0;
  else if (typeof e.duration == "number")
    r.duration = e.duration;
  else {
    const t = r.timestamp - r.started;
    r.duration = t >= 0 ? t : 0;
  }
  e.release && (r.release = e.release), e.environment && (r.environment = e.environment), !r.ipAddress && e.ipAddress && (r.ipAddress = e.ipAddress), !r.userAgent && e.userAgent && (r.userAgent = e.userAgent), typeof e.errors == "number" && (r.errors = e.errors), e.status && (r.status = e.status);
}
const la = "_sentrySpan";
function Ts(r, e) {
  e ? cE(r, la, e) : delete r[la];
}
function Es(r) {
  return r[la];
}
const fE = 100;
class Ja {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = _s();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = new Ja();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e._lastEventId = this._lastEventId, Ts(e, Es(this)), e;
  }
  /**
   * @inheritDoc
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && vE(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, t) {
    return this._tags = { ...this._tags, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, t) {
    return this._extra = { ...this._extra, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, t) {
    return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const t = typeof e == "function" ? e(this) : e, [n, a] = t instanceof Cr ? [t.getScopeData(), t.getRequestSession()] : aE(t) ? [e, e.requestSession] : [], { tags: o, extra: i, user: s, contexts: u, level: l, fingerprint: c = [], propagationContext: f } = n || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...u }, s && Object.keys(s).length && (this._user = s), l && (this._level = l), c.length && (this._fingerprint = c), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Ts(this, void 0), this._attachments = [], this._propagationContext = _s(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, t) {
    const n = typeof t == "number" ? t : fE;
    if (n <= 0)
      return this;
    const a = {
      timestamp: Ya(),
      ...e
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > n ? o.slice(-n) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Es(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = e, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(e, t) {
    const n = t && t.event_id ? t.event_id : Er();
    if (!this._client)
      return Ke.warn("No client configured on scope - will not capture exception!"), n;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: a,
        ...t,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, t, n) {
    const a = n && n.event_id ? n.event_id : Er();
    if (!this._client)
      return Ke.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(e);
    return this._client.captureMessage(
      e,
      t,
      {
        originalException: e,
        syntheticException: o,
        ...n,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, t) {
    const n = t && t.event_id ? t.event_id : Er();
    return this._client ? (this._client.captureEvent(e, { ...t, event_id: n }, this), n) : (Ke.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
const Cr = Ja;
function dE() {
  return Ha("defaultCurrentScope", () => new Cr());
}
function pE() {
  return Ha("defaultIsolationScope", () => new Cr());
}
class $E {
  constructor(e, t) {
    let n;
    e ? n = e : n = new Cr();
    let a;
    t ? a = t : a = new Cr(), this._stack = [{ scope: n }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const t = this._pushScope();
    let n;
    try {
      n = e(t);
    } catch (a) {
      throw this._popScope(), a;
    }
    return oE(n) ? n.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), n);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Ar() {
  const r = za(), e = qa(r);
  return e.stack = e.stack || new $E(dE(), pE());
}
function hE(r) {
  return Ar().withScope(r);
}
function yE(r, e) {
  const t = Ar();
  return t.withScope(() => (t.getStackTop().scope = r, e(r)));
}
function ws(r) {
  return Ar().withScope(() => r(Ar().getIsolationScope()));
}
function gE() {
  return {
    withIsolationScope: ws,
    withScope: hE,
    withSetScope: yE,
    withSetIsolationScope: (r, e) => ws(e),
    getCurrentScope: () => Ar().getScope(),
    getIsolationScope: () => Ar().getIsolationScope()
  };
}
function Zu(r) {
  const e = qa(r);
  return e.acs ? e.acs : gE();
}
function Xa() {
  const r = za();
  return Zu(r).getCurrentScope();
}
function rl() {
  const r = za();
  return Zu(r).getIsolationScope();
}
function mE() {
  return Xa().getClient();
}
function bE(r) {
  if (r)
    return SE(r) ? { captureContext: r } : _E(r) ? {
      captureContext: r
    } : r;
}
function SE(r) {
  return r instanceof Cr || typeof r == "function";
}
const OE = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function _E(r) {
  return Object.keys(r).some((e) => OE.includes(e));
}
function Is(r, e) {
  return Xa().captureException(r, bE(e));
}
function TE(r, e) {
  const t = typeof e == "string" ? e : void 0, n = typeof e != "string" ? { captureContext: e } : void 0;
  return Xa().captureMessage(r, t, n);
}
function EE(r, e) {
  rl().setContext(r, e);
}
const wE = 100;
function ir(r, e) {
  const t = mE(), n = rl();
  if (!t) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = wE } = t.getOptions();
  if (o <= 0) return;
  const s = { timestamp: Ya(), ...r }, u = a ? Xu(() => a(s, e)) : s;
  u !== null && (t.emit && t.emit("beforeAddBreadcrumb", u, e), n.addBreadcrumb(u, o));
}
var Qr;
(function(r) {
  r.Unknown = "unknown", r.Core = "core", r.Routing = "routing-and-presence", r.Insights = "insights", r.Ecosystem = "ecosystem", r.Partners = "partners", r.Channels = "channels", r.Messaging = "messaging", r.Platform = "platform", r.AI = "ai", r.Conversations = "conversations", r.Automation = "automation";
})(Qr || (Qr = {}));
function wr(r) {
  const e = r.split(".")[1];
  if (!e)
    throw Error("Invalid token");
  const t = e.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(t, "base64").toString());
  } catch (n) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${n}`);
  }
}
const IE = Yr.backendDomain ? {
  "backend-domain": Yr.backendDomain
} : void 0;
function Ge() {
  const r = new URLSearchParams(Object.assign({ noToken: "true" }, IE)).toString();
  document.location.href = `${Yr.url.logIn}?${r}`;
}
const xn = "authData", Nn = 30, PE = 600, Ps = 5;
class RE {
  constructor() {
    Object.defineProperty(this, "authData", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "accessTokenExpiresAt", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "clientServerTimeDiff", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const e = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Ps || this.clientServerTimeDiff <= -5 ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(e) {
    this.authData = e;
    const n = Math.ceil(Date.now() / 1e3) + PE, a = wr(e.access_token).exp;
    if (this.clientServerTimeDiff = a - n, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Ps) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(xn, JSON.stringify(e));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const e = localStorage.getItem(xn), t = e ? JSON.parse(e) : null;
    return this.validateAuthDataComplete(t) && (this.authData = t), t;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(xn);
  }
  getAccessToken() {
    var e;
    return ((e = this.authData) === null || e === void 0 ? void 0 : e.access_token) || null;
  }
  getRefreshToken() {
    var e;
    return ((e = this.authData) === null || e === void 0 ? void 0 : e.refresh_token) || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(e) {
    return e ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((n) => typeof e[n] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const t = this.accessTokenExpiresAt - Nn;
    return this.estimatedServerTime() >= t;
  }
  isRefreshTokenExpired(e) {
    if (!e)
      return !0;
    const t = wr(e), n = t.exp - Nn;
    return !t || this.estimatedServerTime() >= n;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Nn - this.estimatedServerTime()) * 1e3;
  }
}
const P = new RE();
var CE = function(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = Promise))(function(o, i) {
    function s(c) {
      try {
        l(n.next(c));
      } catch (f) {
        i(f);
      }
    }
    function u(c) {
      try {
        l(n.throw(c));
      } catch (f) {
        i(f);
      }
    }
    function l(c) {
      c.done ? o(c.value) : a(c.value).then(s, u);
    }
    l((n = n.apply(r, e || [])).next());
  });
};
function AE(r) {
  return CE(this, void 0, void 0, function* () {
    var e, t;
    const n = window.location.origin.replace(/^https?:\/\//, ""), a = ["localhost:8080", "uptrends-monitor"];
    if (!(!r.response || a.some((o) => n.includes(o)))) {
      try {
        const o = (e = r.response.config.headers.Authorization) !== null && e !== void 0 ? e : "", i = o ? (t = o.toString()) === null || t === void 0 ? void 0 : t.split("Basic ")[1] : "", s = i ? atob(i).split("token:")[1] : "", u = s ? wr(s).exp : "None", l = yield Qa.getAuthData({ localStorageOnly: !0 }), c = Math.floor(Date.now() / 1e3), f = l == null ? void 0 : l.access_token, v = l == null ? void 0 : l.refresh_token, d = f ? wr(f).exp : "None", $ = v ? wr(v).exp : "None", h = typeof u == "number" ? c - u : "Unknown", p = typeof d == "number" ? c - d : "Unknown", y = typeof $ == "number" ? c - $ : "Unknown", b = r.response.headers["x-dixa-rid"];
        EE("Expires", {
          currentTimestamp: c,
          accessTokenFromHeader: u,
          accessTokenFromHeaderDiff: h,
          accessTokenFromLocalStorage: d,
          accessTokenFromLocalStorageDiff: p,
          refreshTokenFromLocalStorage: $,
          refreshTokenFromLocalStorageDiff: y,
          xDixaRid: b,
          navigatorOnline: navigator.onLine
        });
      } catch (o) {
        console.error("Error adding Sentry error context", o);
      }
      TE("401 unauthorized interceptor", {
        level: "debug",
        tags: {
          team: Qr.Platform,
          domain: n
        }
      });
    }
  });
}
const kn = /* @__PURE__ */ new Map(), DE = 3;
function jE(r) {
  r.interceptors.response.use((e) => (kn.delete(e.config.url), e), (e) => {
    var t;
    if (e.response) {
      const { status: n } = e.response;
      switch (n) {
        case va.Unauthorized:
          if (!Qa.isRefreshTokenExpired() && e.config) {
            ir({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const a = (t = kn.get(e.config.url)) !== null && t !== void 0 ? t : 0;
            if (console.log(`Retrying request (${a + 1}): ${e.config.url}`), a <= DE)
              return kn.set(e.config.url, a + 1), r(e.config);
          }
          AE(e), console.error("401 unauthorized interceptor"), Ge();
          break;
      }
    }
    return Promise.reject(e);
  });
}
var J = function(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = Promise))(function(o, i) {
    function s(c) {
      try {
        l(n.next(c));
      } catch (f) {
        i(f);
      }
    }
    function u(c) {
      try {
        l(n.throw(c));
      } catch (f) {
        i(f);
      }
    }
    function l(c) {
      c.done ? o(c.value) : a(c.value).then(s, u);
    }
    l((n = n.apply(r, e || [])).next());
  });
};
const el = Cs.create();
jE(el);
const W = console.log;
function Rs(r) {
  return J(this, void 0, void 0, function* () {
    return new Promise((e) => setTimeout(e, r * 1e3));
  });
}
class xE extends Error {
  constructor(e, t) {
    super(e, t);
  }
}
function NE(r = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, r)), 30);
}
const kE = 5;
class ME {
  constructor() {
    Object.defineProperty(this, "authDataPromise", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  init(e) {
    return J(this, void 0, void 0, function* () {
      const t = yield this.refresh(e);
      if (t)
        P.setAuthData(t);
      else {
        const n = P.isRefreshTokenExpired(e) ? "expired" : "unknown";
        throw new xE("Failed to init refresh token", {
          cause: n
        });
      }
    });
  }
  getDebugInfo() {
    const e = P.getAccessToken();
    if (!e)
      return {};
    const t = wr(e), { exp: n } = t;
    return {
      expire: n ? new Date(n * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  getAuthData() {
    return J(this, arguments, void 0, function* ({ localStorageOnly: e = !1 } = {}) {
      if (e)
        return P.getAuthData();
      if (this.authDataPromise)
        return yield this.authDataPromise;
      const t = P.getAuthData();
      return t ? P.isAccessTokenExpired() ? (ir({
        category: "refreshToken",
        // Cannot include "token" in the message, as it will be redacted
        message: "expired or about to expire",
        level: "debug",
        data: this.getDebugInfo()
      }), this.authDataPromise = this.refresh(t.refresh_token).then((n) => (n && P.setAuthData(n), this.authDataPromise = null, n)), yield this.authDataPromise) : t : null;
    });
  }
  removeAuthData() {
    return P.removeAuthData();
  }
  validateAuthDataComplete(e) {
    return P.validateAuthDataComplete(e);
  }
  isAccessTokenExpired() {
    return P.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const e = P.getAuthData();
    return e ? P.isRefreshTokenExpired(e.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  isSupported() {
    return J(this, void 0, void 0, function* () {
      if (!ms.isElectron())
        return !0;
      const e = yield ms.getVersion();
      return eE(e, "3.7.0") === 1;
    });
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  refresh(e) {
    return J(this, arguments, void 0, function* (t, n = kE) {
      try {
        return yield el.post(`${Yr.url.rest}/v2/login/refresh`, {
          refreshToken: t
        }).then((a) => (this.retryCount = 0, a.data.data));
      } catch (a) {
        return yield this.handleRefreshError(a, t, n);
      }
    });
  }
  waitUntilOnline() {
    return J(this, void 0, void 0, function* () {
      const e = navigator.onLine === !1;
      for (e && (W("AUTH", "Network connection offline - waiting..."), ir({
        category: "refreshToken",
        message: "Network connection offline - waiting...",
        level: "debug"
      })); navigator.onLine === !1; )
        yield Rs(5);
      e && (W("AUTH", "Network connection restored"), ir({
        category: "refreshToken",
        message: "Network connection restored",
        level: "debug"
      }));
    });
  }
  retryRefresh(e, t) {
    return J(this, void 0, void 0, function* () {
      yield this.waitUntilOnline(), this.retryCount++;
      const n = NE(this.retryCount);
      return W("AUTH", `Retrying in ${n} seconds`), yield Rs(n), yield this.refresh(e, t);
    });
  }
  handleRefreshError(e, t, n) {
    return J(this, void 0, void 0, function* () {
      var a;
      if (P.isRefreshTokenExpired(t))
        return W("AUTH", "Refresh token expired"), ir({
          category: "refreshToken",
          message: "Refresh token expired",
          level: "debug"
        }), P.removeAuthData(), Ge(), null;
      if (al(e)) {
        if (e.message === "timeout exceeded")
          return W("AUTH", "Timeout exceeded"), ir({
            category: "refreshToken",
            message: "Timeout exceeded",
            level: "debug"
          }), yield this.retryRefresh(t, n);
        if (e.message === "Network Error")
          return W("AUTH", "Network error"), ir({
            category: "refreshToken",
            message: "Network error",
            level: "debug"
          }), yield this.retryRefresh(t, n);
        if (((a = e.response) === null || a === void 0 ? void 0 : a.status) === 401)
          return W("AUTH", "Refresh token invalid (401)"), P.removeAuthData(), Ge(), null;
        Is(e, {
          level: "error",
          tags: {
            team: Qr.Platform,
            errorSource: "authManager.refresh"
          }
        });
      }
      return n <= 0 ? (W("AUTH", "Retries exhausted, logging out"), Is(e, {
        level: "error",
        tags: {
          team: Qr.Platform,
          errorSource: "authManager.refresh"
        }
      }), P.removeAuthData(), Ge(), null) : (W("AUTH", `Retrying ${n} more times`), yield this.retryRefresh(t, n - 1));
    });
  }
  accessTokenExpiresInMs() {
    return P.accessTokenExpiresInMs();
  }
}
const Qa = new ME();
var va;
(function(r) {
  r[r.BadRequest = 400] = "BadRequest", r[r.Unauthorized = 401] = "Unauthorized", r[r.Forbidden = 403] = "Forbidden", r[r.NotFound = 404] = "NotFound", r[r.Conflict = 409] = "Conflict", r[r.InternalServerError = 500] = "InternalServerError", r[r.BadGateway = 502] = "BadGateway", r[r.ServiceUnavailable = 503] = "ServiceUnavailable";
})(va || (va = {}));
const FE = Cs.create();
class LE {
  constructor() {
    /** The current logged in user. */
    Ur(this, "user", null);
    /** The list of authorization scopes assigned to the current user. */
    Ur(this, "scopes", null);
    /** This list of user roles assigned to the current user */
    Ur(this, "_roles", null);
    /** Checks if the user has a certain scope. */
    Ur(this, "hasScope", (e) => this.scopes.includes(e));
  }
  /** Checks if the service has been initialized. */
  get isInitialized() {
    return this.user !== null;
  }
  /** Initializes the access control service. */
  async init({
    user: e
  }) {
    this.user = e;
    const t = await this.introspectAccessToken();
    t && (this.scopes = t.scope, this._roles = t.roles);
  }
  /** Exposed read-only list of user roles assigned to the current user */
  get roles() {
    return this._roles;
  }
  /**
   * Checks if the current user has access to one or more scopes.
   *
   * @param scopes - The scope(s) to check.
   * @param options - The options to use when checking multiple scopes.
   * @param options.strategy - The strategy to use when checking multiple
   *   scopes. Can be "all" or "any".
   * @returns Whether or not the user has access to the scope(s).
   */
  hasAccess(e, t) {
    if (!this.isInitialized || this.scopes === null)
      return !1;
    if (Array.isArray(e)) {
      const { strategy: n = "all" } = t ?? {};
      return n === "all" ? e.every(this.hasScope) : e.some(this.hasScope);
    }
    return this.scopes.includes(e);
  }
  /**
   * Fetches the introspection data of the current access_token and stores it in
   * memory. This should be called only once on init.
   */
  async introspectAccessToken() {
    const e = await Qa.getAuthData({ localStorageOnly: !0 });
    if (!e) return null;
    try {
      return (await FE.post(
        `${Yr.url.rest}/v1/introspect`,
        {
          token: e.access_token
        },
        {
          transformResponse: (n) => {
            const a = JSON.parse(n);
            return {
              ...a,
              /**
               * As per the spec, the backend returns the `scope` as a
               * space-separated string. We convert it to an array of strings to
               * make it easier for us.
               *
               * @see https://datatracker.ietf.org/doc/html/rfc7662#section-2.2
               */
              scope: a.scope ? a.scope.split(" ") : []
            };
          }
        }
      )).data;
    } catch {
      return null;
    }
  }
  reset() {
    this.user = null, this.scopes = null, this._roles = null;
  }
}
const BE = new LE(), VE = (r, e) => ol(
  () => BE.hasAccess(r, e),
  // The arguments are statically defined when consuming the hook, therefore we don't need to
  // recompute the result on every render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []
);
export {
  BE as accessControl,
  VE as useHasAccess
};
//# sourceMappingURL=index.js.map
